<template>
	<!-- Splash Screen - показывается при каждом открытии главной страницы -->
	<SplashAnimate />

	<div class="container-center-horizontal">
		<div
			class="u1075u1083u1072u1074u1085u1072u1103-u1074u1072u1088u1080u1072u1085u1090-9 screen"
		>
			<div class="x7">
				<header class="header">
					<!-- Логотип МеталлТрейд Академия -->
					<div class="logo-container">
						<svg
							class="company-logo"
							width="202"
							height="110"
							viewBox="0 0 202 110"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M102.874 102.362H106.904L104.954 97.5519H104.824L102.874 102.362ZM106.384 96.4469L110.089 105.547H108.217L107.359 103.337H102.419L101.561 105.547H99.6886L103.394 96.4469H106.384ZM116.983 100.932L120.428 105.547H118.283L115.293 101.517H113.018V105.547H111.133V96.4469H113.018V100.542H115.163L118.153 96.4469H120.233L116.983 100.932ZM123.872 102.362H127.902L125.952 97.5519H125.822L123.872 102.362ZM127.382 96.4469L131.087 105.547H129.215L128.357 103.337H123.417L122.559 105.547H120.687L124.392 96.4469H127.382ZM132.001 104.572C132.261 104.572 132.499 104.451 132.716 104.208C132.941 103.965 133.071 103.632 133.106 103.207L133.626 96.4469H140.906V104.572H142.011V107.627H140.451L140.191 105.547H133.171L132.911 107.627H131.351V104.572H132.001ZM134.926 103.207C134.908 103.432 134.852 103.632 134.757 103.805C134.661 103.978 134.557 104.121 134.445 104.234C134.315 104.373 134.172 104.485 134.016 104.572H139.021V97.4219H135.381L134.926 103.207ZM145.327 97.4219V100.412H150.072V101.387H145.327V104.572H151.372V105.547H143.442V96.4469H151.372V97.4219H145.327ZM158.847 104.247H158.977L162.357 96.4469H165.152V105.547H163.267V98.2669H163.137L160.017 105.547H157.807L154.687 98.2669H154.557V105.547H152.672V96.4469H155.467L158.847 104.247ZM174.442 105.547V98.1369H174.312L169.437 105.547H166.967V96.4469H168.852V103.857H168.982L173.857 96.4469H176.327V105.547H174.442ZM177.761 105.547L179.906 102.479C179.256 102.228 178.758 101.864 178.411 101.387C178.065 100.91 177.891 100.325 177.891 99.6319C177.891 99.1292 177.987 98.6829 178.177 98.2929C178.368 97.8942 178.641 97.5605 178.996 97.2919C179.352 97.0145 179.785 96.8065 180.296 96.6679C180.816 96.5205 181.401 96.4469 182.051 96.4469H186.731V105.547H184.846V102.817H182.051H181.817L179.906 105.547H177.761ZM182.051 97.4219C181.367 97.4219 180.838 97.6039 180.465 97.9679C180.093 98.3232 179.906 98.8779 179.906 99.6319C179.906 100.386 180.093 100.945 180.465 101.309C180.838 101.664 181.367 101.842 182.051 101.842H184.846V97.4219H182.051Z"
								fill="white"
							/>
							<path
								d="M197.625 81.0322H202.001V91.4824H196.517V85.9365H175.161V91.4824H169.969V81.0322H175.867C175.952 80.9242 176.095 80.6594 176.095 80.2734V53.0098H197.625V81.0322ZM181.58 81.0322H192.141V57.6221H181.58V81.0322Z"
								fill="#0096ed"
							/>
							<path
								d="M150.067 71.909L160.044 66.7751V53.01H165.821V85.645H160.044V72.5835L150.067 77.7175V85.645H144.582V52.7181H150.067V71.909Z"
								fill="#0096ed"
							/>
							<path
								d="M159.163 53.7141L159.073 53.7962L155.281 57.2991L155.201 57.3726L155.122 57.2991L151.33 53.7962L151.24 53.7141L153.159 51.7939L155.201 53.8373L157.243 51.7939L159.163 53.7141Z"
								fill="#0096ed"
							/>
							<path
								d="M132.277 53.2773C133.965 53.4308 135.138 54.2535 135.88 55.2285C136.591 56.1637 136.899 57.2242 136.967 57.9697L136.972 58.0293V66.6143L136.967 66.6729C136.662 70.025 133.828 71.5468 132.504 71.9082L132.334 71.9541H122.385V67.2842H130.991C131.296 67.2842 131.488 67.2289 131.604 67.1768C131.717 67.1254 131.791 67.0611 131.845 66.9961C131.969 66.8451 132.013 66.6451 132.013 66.5537V58.9648C132.013 58.4248 131.858 58.1692 131.767 58.0586C131.719 58.0006 131.673 57.9648 131.641 57.9434H122.239C121.874 57.9434 121.689 58.0112 121.61 58.0518C121.542 58.087 121.519 58.1194 121.503 58.1475C121.481 58.1877 121.456 58.2589 121.448 58.3652C121.441 58.4729 121.454 58.5767 121.471 58.6455L121.51 58.8027V80.2734C121.51 80.8154 121.662 80.9696 121.676 80.9834C121.687 80.9946 121.698 80.9995 121.704 81.0029H130.991C131.529 81.0029 131.849 80.8257 132.013 80.6953V74.6396H136.972V81.1494C136.972 82.4536 136.276 83.4732 135.604 84.1484C134.925 84.8311 134.127 85.3113 133.566 85.5605L133.312 85.6738H121.234L121.106 85.6484C118.296 85.086 116.933 83.2529 116.602 82.0938L116.551 81.917V57.5049C116.551 56.238 117.16 55.2674 117.808 54.6162C118.445 53.9755 119.196 53.559 119.736 53.3564L119.959 53.2725H132.218L132.277 53.2773Z"
								fill="#0096ed"
							/>
							<path
								d="M106.514 52.6367C107.463 52.7867 108.882 53.2493 110.068 54.1562C111.26 55.0675 112.225 56.4356 112.226 58.3799V58.3828L111.934 82.0264V82.0479L111.929 82.0693C111.625 83.3858 110.17 86.0194 106.774 86.0195H96.6553V80.9482H106.088C106.114 80.9035 106.15 80.8332 106.183 80.7305C106.237 80.5598 106.282 80.3128 106.282 79.9814V58.3799C106.282 58.2659 106.247 58.0901 106.146 57.9492C106.051 57.8185 105.892 57.7041 105.607 57.7041H96.6621C96.5887 57.8166 96.4717 58.0694 96.4717 58.46V99.1543H90.8203V57.4922H90.8213C90.8721 56.6792 91.205 55.4688 92.041 54.458C92.8835 53.4394 94.2283 52.6339 96.2715 52.6338H106.498L106.514 52.6367Z"
								fill="#0096ed"
							/>
							<path
								d="M163.371 19.2656V49.0398H161.037V21.3089H147.909V45.8288C147.909 46.9964 147.034 48.7479 144.408 49.0398H141.199V46.9964H144.117C145.867 46.7045 145.575 45.8288 145.575 44.0774V19.2656H163.371Z"
								fill="white"
							/>
							<path
								d="M135.949 18.9736V48.7478H133.615V21.017H120.487V45.5368C120.487 46.7044 119.612 48.4559 116.986 48.7478H113.777V46.7044H116.695C118.445 46.4125 118.153 45.5368 118.153 43.7854V18.9736H135.949Z"
								fill="white"
							/>
							<path
								d="M105.211 18.5986C106.865 18.5986 107.891 19.1286 108.485 20.0791C109.066 21.0069 109.209 22.2991 109.209 23.7607V23.8203C109.209 23.859 109.208 23.9174 109.208 23.9922C109.207 24.1422 109.207 24.3624 109.206 24.6426C109.204 25.2041 109.201 26.0085 109.197 26.9775C109.191 28.9159 109.182 31.516 109.173 34.1611C109.155 39.4521 109.138 44.925 109.138 45.6543C109.138 46.4101 108.986 47.0426 108.586 47.5635C108.187 48.0815 107.562 48.4644 106.667 48.7627C106.424 48.8435 106.052 48.8995 105.604 48.9395C105.152 48.9798 104.604 49.0058 104.001 49.0195C102.793 49.047 101.348 49.0287 99.9609 48.9922C98.5738 48.9557 97.241 48.9001 96.2559 48.8545C95.7635 48.8317 95.357 48.8117 95.0742 48.7969C94.933 48.7895 94.8213 48.7834 94.7461 48.7793C94.7089 48.7773 94.6794 48.7755 94.6602 48.7744C94.651 48.7739 94.6434 48.7737 94.6387 48.7734C94.6364 48.7732 94.634 48.7725 94.6328 48.7725H94.624C93.2795 48.6499 92.3791 48.0092 91.8066 47.2568C91.2389 46.5104 90.994 45.6551 90.9424 45.0879L90.9414 45.0791V36.5957L90.9424 36.5869C91.1866 33.8994 93.4811 32.628 94.5898 32.3252L94.6152 32.3184H103.303V34.7617H95.8096C94.9311 34.7619 94.4056 35.0795 94.0967 35.4551C93.7816 35.8386 93.6759 36.302 93.6758 36.6045V44.1943C93.6759 45.7114 94.5559 46.2405 94.958 46.3301H104.562C105.125 46.3301 105.512 46.2411 105.775 46.1094C106.034 45.9799 106.185 45.8034 106.276 45.6064C106.37 45.4043 106.404 45.17 106.413 44.9219C106.422 44.6609 106.403 44.4383 106.403 44.1943C106.403 43.7559 106.409 38.4282 106.415 33.2109C106.418 30.6024 106.421 28.0209 106.423 26.0918C106.424 25.1274 106.424 24.3251 106.425 23.7646C106.425 23.485 106.426 23.265 106.426 23.1152V22.8809C106.45 21.897 106.175 21.4745 105.823 21.2705C105.636 21.1622 105.407 21.1035 105.143 21.0732C104.878 21.0429 104.591 21.042 104.292 21.042H96.1016C95.9524 21.042 95.7981 21.0377 95.6475 21.0332C95.4958 21.0286 95.3458 21.0234 95.1992 21.0234C94.9037 21.0235 94.634 21.0424 94.4062 21.1074C94.1825 21.1715 94.0067 21.278 93.8848 21.4502C93.7613 21.6249 93.6758 21.8908 93.6758 22.3018V27.1719H90.9414V22.124C90.9422 19.838 92.8023 18.599 94.3516 18.5986H105.211Z"
								fill="white"
							/>
							<path
								d="M77.5971 99.2472H72.6376L72.3459 20.4333L41.4219 0.291992H109.396L77.5971 20.4333V99.2472Z"
								fill="#0096ed"
							/>
							<path
								d="M59.2179 22.7685C59.1207 21.6982 58.2843 19.4991 55.7171 19.2656H43.7558C42.9778 19.5575 41.4219 20.55 41.4219 22.1847V46.4126C41.6164 47.0937 42.5888 48.5727 44.9227 49.0398H56.5921C57.4673 48.6506 59.2178 47.4635 59.2178 45.8288V42.6179H56.8839V45.8288C56.6894 46.218 55.9503 46.9964 54.55 46.9964H45.2144C44.7282 46.9964 43.7558 46.5878 43.7559 44.9531V23.6442C43.5614 22.8658 43.6976 21.3089 45.7981 21.3089H55.4253C55.9116 21.4062 56.884 22.0095 56.884 23.6442V31.2337C56.884 31.9148 56.4172 33.277 54.5501 33.277H47.2567V35.3203H55.7171C56.7868 35.0284 58.9845 33.8024 59.2179 31.2337V22.7685Z"
								fill="white"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M30.067 0.0159635V0.0125427H32.9844V49.0523H30.067V2.09977L18.5184 33.5426L18.5964 33.5814H18.5041L18.4956 33.6054L18.4306 33.5814H14.5537L14.4888 33.6054L14.4802 33.5814H14.3879L14.4654 33.5426L2.91736 2.09977V49.0523H0V0.0125427H2.91736V0.0159635L4.68544 0L4.66948 0.0176738L16.4922 32.2057L28.3149 0.0176738L28.2989 0L30.067 0.0159635ZM16.4876 32.8693L16.4922 32.871L16.4962 32.8693L16.4922 32.8676L16.4876 32.8693Z"
								fill="white"
							/>
						</svg>
					</div>
					<div
						class="group-452"
						:style="{ 'background-image': 'url(' + group452 + ')' }"
					>
						<div class="view">
							<div class="group-7">
								<div class="rectangle-6"></div>
								<div class="text-108 nunitosans-bold-white-24px">
									{{ text108 }}
								</div>
								<div class="text-109 nunitosans-semi-bold-white-20px">
									{{ text109 }}
								</div>
								<img class="group-6" :src="group6" alt="Group 6" />
							</div>
							<div class="group-10">
								<div class="rectangle-6-1"></div>
								<div class="text-106 nunitosans-bold-white-24px">
									{{ text106 }}
								</div>
								<div class="text-107 nunitosans-semi-bold-white-20px">
									{{ text107 }}
								</div>
								<div class="group-6-1"></div>
								<img
									class="email-2-1"
									src="/assets/cdn-animaapp/email-2-1-1.svg?v=2"
									alt="email 2 1"
								/>
							</div>
							<div class="group-13">
								<div class="rectangle-6-2"></div>
								<div class="din nunitosans-bold-white-24px">{{ din }}</div>
								<div class="text-104 nunitosans-semi-bold-white-20px">
									{{ text104 }}
								</div>
								<div class="group-12">
									<div class="rectangle-3"></div>
									<div class="text-105 nunitosans-bold-white-20px">
										{{ text105 }}
									</div>
								</div>
								<img class="ellipse" :src="ellipse" alt="Ellipse" />
								<div class="ellipse-4"></div>
							</div>
						</div>
						<div class="group-450">
							<div class="text-110">{{ text110 }}</div>
							<p class="text-111">{{ text111 }}</p>
							<div class="group-449">
								<div class="group-3">
									<div class="rectangle-3-1"></div>
									<div class="text-112">{{ text112 }}</div>
								</div>
							</div>
						</div>
						<div class="group-447">
							<div class="group-446">
								<a href="#text_label">
									<div class="text-115 poppins-normal-white-22px">
										{{ text115 }}
									</div> </a
								><a href="#view">
									<div class="text-116 poppins-normal-white-22px">
										{{ text116 }}
									</div> </a
								><a href="#text-55">
									<div class="text-118 poppins-normal-white-22px">
										{{ text118 }}
									</div> </a
								><a href="#rectangle">
									<div class="text-117 poppins-normal-white-22px">
										{{ text117 }}
									</div> </a
								><a href="#view-8">
									<div class="text-119 poppins-normal-white-22px">
										{{ text119 }}
									</div> </a
								><a href="#view-9">
									<div class="text-120 poppins-normal-white-22px">
										{{ text120 }}
									</div>
								</a>
							</div>
							<div class="group-445">
								<div class="group-1">
									<router-link to="/auth">
										<div class="rectangle-2"></div>
										<div class="text-113">{{ text113 }}</div>
									</router-link>
								</div>

								<div class="group-113">
									<router-link
										to="/auth?tab=registration"
										class="registration-link"
									>
										<div class="rectangle-2-1"></div>
										<div class="text-114">{{ text114 }}</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="x3">
						<div class="text-121">{{ text121 }}</div>
						<img class="image" :src="image1" alt="image" />
					</div>
				</header>
				<div class="view-1">
					<div class="frame-55">
						<div class="frame">
							<h1
								class="address arial-regular-normal-azure-radiance-96px counter-animate"
								data-counter-target="5000"
							>
								0
							</h1>
							<div class="text-10-1 arial-regular-normal-blue-charcoal-32px">
								{{ text101 }}
							</div>
						</div>
						<div class="frame-49">
							<p class="address-1 arial-regular-normal-azure-radiance-96px">
								<span
									><span
										class="span0 arial-regular-normal-azure-radiance-96px counter-animate"
										data-counter-target="300000"
										>0</span
									><span
										class="span1 arial-regular-normal-azure-radiance-96px"
										>{{ spanText2 }}</span
									>
								</span>
							</p>
							<div class="text-10-1 arial-regular-normal-blue-charcoal-32px">
								{{ text102 }}
							</div>
						</div>
						<div class="frame">
							<div
								class="address-2 arial-regular-normal-azure-radiance-96px counter-animate"
								data-counter-target="16"
							>
								0
							</div>
							<div class="text-103 arial-regular-normal-blue-charcoal-32px">
								{{ text103 }}
							</div>
						</div>
					</div>
					<div class="frame-54">
						<p class="text_label" id="text_label">{{ text_Label1 }}</p>
					</div>
				</div>
				<div class="view-2">
					<div class="text-95 poppins-bold-thunder-40px">{{ text95 }}</div>
					<p class="text-96 poppins-normal-storm-dust-24px" v-html="text96"></p>
					<div class="x3-1">
						<div class="rectangle-1"></div>
						<div class="text-97 poppins-bold-thunder-27px">{{ text97 }}</div>
						<p class="text-98 poppins-normal-storm-dust-20px">{{ text98 }}</p>
						<div class="group">
							<div class="users-1">
								<img
									class="vector"
									src="@/assets/cdn-animaapp/users-1.svg"
									alt="Vector"
								/>
							</div>
						</div>
					</div>
					<div class="x2">
						<div class="rectangle-15"></div>
						<div class="hr poppins-bold-thunder-27px">{{ hr }}</div>
						<p class="text_label-1 poppins-normal-storm-dust-20px">
							{{ text_Label2 }}
						</p>
						<img class="group-80" :src="group80" alt="Group 80" />
					</div>
					<div class="x1">
						<div class="rectangle-1"></div>
						<div class="text-99 poppins-bold-thunder-27px">{{ text99 }}</div>
						<p class="text-100 poppins-normal-storm-dust-20px">{{ text100 }}</p>
						<div class="group">
							<div class="file-invoice-1"></div>
						</div>
					</div>
				</div>
				<div class="view-3">
					<p class="text-89 poppins-normal-storm-dust-24px">{{ text89 }}</p>
					<div class="text-90">
						<span class="span0-1">{{ spanText3 }}</span
						><span class="span1-1">{{ spanText4 }}</span>
					</div>
					<div class="group-22">
						<img
							class="rectangle-19"
							:src="rectangle19"
							alt="Rectangle 19"
						/>
					</div>
					<div
						class="group-23"
						:style="{ 'background-image': 'url(' + group23 + ')' }"
					>
						<div class="rectangle-23"></div>
					</div>
					<div class="text-91 poppins-semi-bold-white-32px">{{ text91 }}</div>
					<div class="text-92 poppins-semi-bold-white-32px">{{ text92 }}</div>
					<div class="group-20">
						<div class="rectangle-24"></div>
						<div class="text-93 poppins-medium-white-22px">{{ text93 }}</div>
					</div>
					<div class="group-21">
						<div class="rectangle-24-1"></div>
						<div class="text-94 poppins-medium-white-22px">{{ text94 }}</div>
					</div>
				</div>
				<div class="view-4" id="view">
					<div class="text-56">
						<span class="poppins-bold-thunder-40px">{{ spanText5 }}</span
						><span class="span1-2">{{ spanText6 }}</span>
					</div>
					<p class="text-57">{{ text57 }}</p>
					<div class="group-37">
						<div class="rectangle-31"></div>
						<div class="text-58">{{ text58 }}</div>
					</div>
					<div class="group-83">
						<p class="text-59 poppins-semi-bold-white-40px">
							<span class="poppins-semi-bold-thunder-40px">{{ spanText7 }}</span
							><span class="poppins-semi-bold-azure-radiance-40px">{{
								spanText8
							}}</span
							><span class="poppins-semi-bold-thunder-40px">{{
								spanText9
							}}</span>
						</p>
						<div class="ellipse-19"></div>
						<div class="ellipse-20"></div>
						<div class="ellipse-21"></div>
						<div class="ellipse-22"></div>
						<div class="group-71">
							<div class="group-67">
								<div class="rectangle-50"></div>
								<div class="ellipse-16"></div>
								<div class="ellipse-17"></div>
								<div class="ellipse-18"></div>
							</div>
							<div class="group-55">
								<div class="rectangle-43"></div>
								<div class="text-60 nunitosans-bold-white-22-1px">
									{{ text60 }}
								</div>
							</div>
							<div class="group-56">
								<div class="rectangle-45"></div>
								<div class="rectangle-44"></div>
								<div class="text-61 nunitosans-bold-white-22-1px">
									{{ text61 }}
								</div>
							</div>
							<div class="group-57">
								<img
									class="mask-group"
									:src="maskGroup1"
									alt="Mask Group"
								/><img
									class="mask-group-1"
									:src="maskGroup2"
									alt="Mask Group"
								/>
								<div class="group-61">
									<div class="rectangle-6-3"></div>
									<div class="rectangle-7"></div>
									<div class="text-62 nunitosans-semi-bold-white-11-1px">
										{{ text62 }}
									</div>
									<div class="text-63">{{ text63 }}</div>
									<group58 />
								</div>
							</div>
							<div
								class="group-64"
								:style="{ 'background-image': 'url(' + group641 + ')' }"
							>
								<div class="group-59">
									<div class="rectangle-6-4"></div>
									<div class="a">{{ a }}</div>
									<group58 :className="group58Props.className" />
								</div>
							</div>
							<div
								class="group-63"
								:style="{ 'background-image': 'url(' + group631 + ')' }"
							>
								<div class="group-60">
									<div class="rectangle-6-5"></div>
									<div class="text-64 nunitosans-semi-bold-white-11-1px">
										{{ text64 }}
									</div>
									<group582 />
								</div>
							</div>
							<div
								class="group-65"
								:style="{ 'background-image': 'url(' + group65 + ')' }"
							>
								<div class="group-61-1">
									<div class="rectangle-6-6"></div>
									<div class="text-65 nunitosans-semi-bold-white-11-1px">
										{{ text65 }}
									</div>
									<group582 :className="group582Props.className" />
								</div>
							</div>
							<div
								class="group-66"
								:style="{ 'background-image': 'url(' + group66 + ')' }"
							>
								<div class="group-62">
									<div class="rectangle-6-7"></div>
									<div class="text-66">{{ text66 }}</div>
									<div class="group-58">
										<div class="rectangle-46"></div>
										<div class="rectangle-47"></div>
										<div class="rectangle-48"></div>
									</div>
								</div>
							</div>
							<img class="group-70" :src="group70" alt="Group 70" />
						</div>
						<div class="group-453 poppins-normal-pale-sky-22px">
							<p class="text-67">{{ text67 }}</p>
							<div class="ellipse-24"></div>
							<div class="ellipse-25"></div>
							<div class="ellipse-26"></div>
							<p class="text-68">{{ text68 }}</p>
							<div class="group-72">
								<div class="rectangle-51"></div>
								<div class="rectangle-53"></div>
								<div class="rectangle-52"></div>
								<div class="rectangle-54"></div>
							</div>
							<p class="text-69">{{ text69 }}</p>
							<div class="group-73">
								<div class="rectangle-56"></div>
								<div class="rectangle-55"></div>
							</div>
							<div class="users-2">
								<img
									class="vector"
									src="@/assets/cdn-animaapp/users-2.svg"
									alt="Vector"
								/>
							</div>
						</div>
					</div>
					<div class="group-123">
						<p class="text-70 poppins-normal-pale-sky-22px">{{ text70 }}</p>
						<p class="text-71 poppins-semi-bold-white-40px">
							<span class="poppins-semi-bold-azure-radiance-40px">{{
								spanText10
							}}</span
							><span class="poppins-semi-bold-thunder-40px">{{
								spanText11
							}}</span>
						</p>
						<img class="group-122" :src="group122" alt="Group 122" />
					</div>
					<div class="group-93">
						<div class="group-92">
							<div class="ellipse-105"></div>
							<div class="ellipse-108"></div>
							<div class="ellipse-106"></div>
							<div class="ellipse-107"></div>
							<div class="rectangle-63"></div>
							<p class="text-74" v-html="text74"></p>
							<div class="group-90">
								<div class="ellipse-102"></div>
								<div class="ellipse-101"></div>
								<img
									class="vector-7"
									src="@/assets/cdn-animaapp/Group-90.svg"
									alt="Vector 7"
								/>
							</div>
							<div class="group-88">
								<div class="ellipse-102-1"></div>
								<div class="group-85">
									<div class="ellipse-101-1"></div>
									<img
										class="vector-6"
										src="@/assets/cdn-animaapp/Group-88.svg"
										alt="Vector 6"
									/>
								</div>
							</div>
							<div class="rectangle-64"></div>
							<div class="text-75">{{ text75 }}</div>
							<img class="mask-group-2" :src="maskGroup3" alt="Mask Group" />
							<div class="group-89">
								<div class="rectangle-65"></div>
								<div class="ellipse-103"></div>
								<div class="ellipse-104"></div>
								<div class="text-76">{{ text76 }}</div>
								<img class="group-86" :src="group86" alt="Group 86" />
							</div>
						</div>
						<div class="group-118">
							<div class="text-73 poppins-semi-bold-white-40px">
								<span class="poppins-semi-bold-thunder-40px">{{
									spanText12
								}}</span
								><span class="poppins-semi-bold-azure-radiance-40px">{{
									spanText13
								}}</span
								><span class="poppins-semi-bold-thunder-40px">{{
									spanText14
								}}</span>
							</div>
							<p
								class="text-72 poppins-normal-pale-sky-22px"
								v-html="text72"
							></p>
						</div>
					</div>
					<div class="group-125">
						<p class="text-77 poppins-normal-pale-sky-22px">{{ text77 }}</p>
						<div class="text-78 poppins-semi-bold-white-40px">
							<span class="poppins-semi-bold-thunder-40px">{{
								spanText15
							}}</span
							><span class="poppins-semi-bold-azure-radiance-40px">{{
								spanText16
							}}</span>
						</div>
						<div class="group-124">
							<div class="rectangle-75"></div>
							<div class="ellipse-112"></div>
							<div class="ellipse-113"></div>
							<div class="rectangle-65-1"></div>
							<div class="rectangle-66"></div>
							<div class="rectangle-71"></div>
							<div class="rectangle-72"></div>
							<div class="rectangle-73"></div>
							<div class="rectangle-74"></div>
							<div class="text-79">{{ text79 }}</div>
							<div class="group-91">
								<div class="rectangle-68"></div>
								<div class="rectangle-67"></div>
								<div class="text-80 poppins-medium-white-22px">
									{{ text80 }}
								</div>
							</div>
							<img
								class="mask-group-3"
								:src="maskGroup4"
								alt="Mask Group"
							/><img
								class="mask-group-4"
								:src="maskGroup5"
								alt="Mask Group"
							/><img
								class="mask-group-5"
								:src="maskGroup6"
								alt="Mask Group"
							/><img class="mask-group-6" :src="maskGroup7" alt="Mask Group" />
							<div class="rectangle-67-1"></div>
							<div class="rectangle-68-1"></div>
							<div class="rectangle-69"></div>
							<div class="rectangle-70"></div>
							<div class="number">{{ number1 }}</div>
							<div class="number-1">{{ number2 }}</div>
							<div class="number-2">{{ number3 }}</div>
							<div class="number-3">{{ number4 }}</div>
							<img
								class="star-6"
								src="@/assets/cdn-animaapp/Star-6.svg"
								alt="Star 6"
							/>
							<div class="group-94">
								<div class="ellipse-115"></div>
								<div class="ellipse-114"></div>
								<img
									class="star-7"
									src="@/assets/cdn-animaapp/star-7-1.svg"
									alt="Star 7"
								/>
							</div>
							<img class="group-95" :src="group95" alt="Group 95" />
							<div class="group-96">
								<img
									class="vector-8"
									src="@/assets/cdn-animaapp/vector-8-1.svg"
									alt="Vector 8"
								/>
								<img
									class="vector-9"
									src="@/assets/cdn-animaapp/vector-9-1.svg"
									alt="Vector 9"
								/>
								<img
									class="vector-10"
									src="@/assets/cdn-animaapp/vector-10-1.svg"
									alt="Vector 10"
								/>
							</div>
						</div>
					</div>
					<div class="group-107">
						<div class="group-106">
							<div class="ellipse-118"></div>
							<img
								class="polygon-3"
								src="@/assets/cdn-animaapp/polygon-3-1.svg"
								alt="Polygon 3"
							/>
							<div class="rectangle-79-1"></div>
							<div class="group-104">
								<div class="group-67-1">
									<div class="rectangle-50-1"></div>
									<div class="ellipse-16-1"></div>
									<div class="ellipse-17-1"></div>
									<div class="ellipse-18-1"></div>
								</div>
								<div class="group-55-1">
									<div class="rectangle-43-1"></div>
									<div class="text-83 nunitosans-bold-white-16-8px">
										{{ text83 }}
									</div>
								</div>
								<div class="group-56-1">
									<div class="rectangle-44-1"></div>
									<div class="text-84 nunitosans-bold-white-16-8px">
										{{ text84 }}
									</div>
									<div class="phone-1-1"></div>
								</div>
								<div
									class="group-64-1"
									:style="{ 'background-image': 'url(' + group642 + ')' }"
								></div>
								<div
									class="group-63-1"
									:style="{ 'background-image': 'url(' + group632 + ')' }"
								></div>
								<img class="group-101" :src="group101" alt="Group 101" />
								<div class="rectangle-77"></div>
							</div>
							<div class="group-103">
								<div class="rectangle-76"></div>
								<div class="rectangle-78-1"></div>
								<div
									class="group-57-1"
									:style="{ 'background-image': 'url(' + group57 + ')' }"
								></div>
								<div
									class="group-99"
									:style="{ 'background-image': 'url(' + group99 + ')' }"
								>
									<div class="group-62-1">
										<div class="rectangle-6-8"></div>
										<div class="text-85">{{ text85 }}</div>
										<div class="group-58-1">
											<div class="rectangle-46-1"></div>
											<div class="rectangle-47-1"></div>
											<div class="rectangle-48-1"></div>
										</div>
									</div>
								</div>
								<div class="group-100">
									<div class="rectangle-68-2"></div>
									<div class="rectangle-67-2"></div>
									<div class="text-86">{{ text86 }}</div>
								</div>
								<div class="text-87">{{ text87 }}</div>
								<p class="text-88">{{ text88 }}</p>
								<div class="group-102">
									<div class="ellipse-16-2"></div>
									<div class="ellipse-17-2"></div>
									<div class="ellipse-18-2"></div>
								</div>
								<img
									class="line-9"
									src="/assets/cdn-animaapp/line-9-1.svg"
									alt="Line 9"
								/>
							</div>
							<div class="group-105">
								<div class="ellipse-117"></div>
								<div class="ellipse-116"></div>
								<div class="user-friends-1">
									<img
										class="vector-1"
										src="@/assets/cdn-animaapp/vector-15.svg"
										alt="Vector"
									/>
								</div>
							</div>
						</div>
						<div class="group-119">
							<div class="text-82 poppins-semi-bold-white-40px">
								<span class="poppins-semi-bold-thunder-40px">{{
									spanText17
								}}</span
								><span class="poppins-semi-bold-azure-radiance-40px">{{
									spanText18
								}}</span>
							</div>
							<p class="text-81 poppins-normal-pale-sky-22px">{{ text81 }}</p>
						</div>
					</div>
				</div>
				<div class="view-5">
					<div class="x1-1">
						<div class="group-245">
							<div class="text-54">{{ text54 }}</div>
							<p class="text-53 poppins-normal-storm-dust-25px">{{ text53 }}</p>
						</div>
						<img class="group-40" :src="group401" alt="Group 40" />
					</div>
					<div class="rectangle-206"></div>
					<div class="rectangle-205"></div>
					<p class="text-55 poppins-bold-black-40px" id="text-55">
						{{ text55 }}
					</p>
				</div>
				<div class="view-6">
					<div class="rectangle" id="rectangle"></div>
					<div class="x2-1">
						<div class="rectangle-4"></div>
						<div class="group-454">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<div class="x roboto-bold-bunker-24px">{{ CqZ22j }}</div>
							<p class="x-1 poppins-normal-pale-sky-15px" v-html="hyMyEz"></p>
							<img class="group-457" :src="group4571" alt="Group 457" />
						</div>
						<div class="group-457-1">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<div class="x-2 roboto-bold-bunker-24px">{{ vIqT8D }}</div>
							<p class="x-3 poppins-normal-pale-sky-15px" v-html="B2cUJU"></p>
							<img class="group-457" :src="group4572" alt="Group 457" />
						</div>
						<div class="group-458">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<div class="x-4 roboto-bold-bunker-24px">{{ wsuwVx }}</div>
							<div
								class="x-5 poppins-normal-pale-sky-15px"
								v-html="vT82Fp"
							></div>
							<img class="group-457" :src="group4573" alt="Group 457" />
						</div>
						<button-see-all />
						<div class="text-47 roboto-bold-black-28px">{{ text47 }}</div>
					</div>
					<div class="x1-2">
						<div class="rectangle-5"></div>
						<div class="group-454-1">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<div class="x-6 roboto-bold-bunker-24px">{{ JPDgjQ }}</div>
							<p
								class="x-7 poppins-normal-storm-dust-15px"
								v-html="x01FWBT"
							></p>
							<img class="group-457" :src="group4574" alt="Group 457" />
						</div>
						<div class="group-457-2">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<p class="x-8 roboto-bold-bunker-24px">{{ x9KS2d1 }}</p>
							<p class="x-9 poppins-normal-storm-dust-15px" v-html="YidcRU"></p>
							<img class="group-457" :src="group4575" alt="Group 457" />
						</div>
						<div class="group-458-1">
							<div class="rectangle-199"></div>
							<group456 />
							<group455 />
							<div class="x-10 roboto-bold-bunker-24px" v-html="e29FLh"></div>
							<p
								class="x-11 poppins-normal-storm-dust-15px"
								v-html="x8usXG1"
							></p>
							<img class="group-457" :src="group4576" alt="Group 457" />
						</div>
						<button-see-all :className="buttonSeeAllProps.className" />
						<p class="text-52 roboto-bold-black-28px">{{ text52 }}</p>
					</div>
					<div class="view-7">
						<p class="text_label-2">{{ text_Label3 }}</p>
						<div class="text_label-3">{{ text_Label4 }}</div>
					</div>
				</div>
				<div class="view-8" id="view-8">
					<!-- Слайдер отзывов -->
					<div class="x-12 review-slider">
						<img
							class="mask-group-7"
							:src="currentReview.image"
							alt="Mask Group"
						/>
						<div class="x-13">
							<div class="rectangle-28"></div>
							<div class="rectangle-30"></div>
							<img
								class="line-3"
								src="/assets/cdn-animaapp/line-3-1.svg"
								alt="Line 3"
							/>
							<p class="text-35">{{ currentReview.text }}</p>
							<div class="text-36">{{ currentReview.name }}</div>
							<div class="address-3">{{ currentReview.info }}</div>
							<div class="group-29">
								<img
									class="star-1"
									src="@/assets/cdn-animaapp/star-1-1.svg"
									alt="Star 1"
								/>
								<img
									class="star"
									src="@/assets/cdn-animaapp/star-2-1.svg"
									alt="Star 2"
								/>
								<img
									class="star"
									src="@/assets/cdn-animaapp/star-3-1.svg"
									alt="Star 3"
								/>
								<img
									class="star"
									src="@/assets/cdn-animaapp/star-4-1.svg"
									alt="Star 4"
								/>
								<img
									class="star"
									src="@/assets/cdn-animaapp/star-5-1.svg"
									alt="Star 5"
								/>
							</div>
						</div>
						<div class="group-51" @click="nextReview">
							<img
								class="vector-5"
								src="@/assets/cdn-animaapp/vector-5-1.svg"
								alt="Vector 5"
							/>
						</div>
					</div>
					<div class="x-14" id="-">
						<div class="x-15">
							<img
								class="line-4"
								src="@/assets/cdn-animaapp/line-4-1.svg"
								alt="Line 4"
							/>
							<div class="text-42">{{ text42 }}</div>
						</div>
						<div class="text-41">{{ text41 }}</div>
						<p class="text-40 poppins-normal-storm-dust-26px">{{ text40 }}</p>
						<p class="text-39 poppins-normal-storm-dust-26px">{{ text39 }}</p>
						<p
							class="text-38 poppins-normal-storm-dust-26px"
							v-html="text38"
						></p>
						<div class="group-459">
							<div class="rectangle-29"></div>
							<div class="text-37">{{ text37 }}</div>
							<div class="group-32">
								<img
									class="arrow-2"
									src="@/assets/cdn-animaapp/arrow-2-1.svg"
									alt="Arrow 2"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="view-9" id="view-9">
					<x5332 />
					<x5332 :className="x53321Props.className" />
					<x5332 :className="x53322Props.className" />
					<div class="x50">
						<div
							class="group-40-1"
							:style="{ 'background-image': 'url(' + group402 + ')' }"
						></div>
						<p class="metall-traderu">{{ metallTradeRu }}</p>
						<div class="address-4">{{ address4 }}</div>
						<p class="text-31 poppins-normal-storm-dust-20px">{{ text31 }}</p>
						<div class="text-32 poppins-normal-storm-dust-20px">
							{{ text32 }}
						</div>
						<group460 :className="group460Props.className" />
					</div>
					<div class="text-34">{{ text34 }}</div>
				</div>
				<div class="view-10">
					<footer class="footer">
						<div class="rectangle-80-2"></div>
						<div class="footer-content">
							<div class="footer-left">
								<div class="f-logo">
									<svg
										class="footer-logo"
										width="321"
										height="174"
										viewBox="0 0 321 174"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M163.407 161.711H170.227L166.927 153.571H166.707L163.407 161.711ZM169.347 151.701L175.617 167.101H172.449L170.997 163.361H162.637L161.185 167.101H158.017L164.287 151.701H169.347ZM187.284 159.291L193.114 167.101H189.484L184.424 160.281H180.574V167.101H177.384V151.701H180.574V158.631H184.204L189.264 151.701H192.784L187.284 159.291ZM198.942 161.711H205.762L202.462 153.571H202.242L198.942 161.711ZM204.882 151.701L211.152 167.101H207.984L206.532 163.361H198.172L196.72 167.101H193.552L199.822 151.701H204.882ZM212.699 165.451C213.139 165.451 213.542 165.246 213.909 164.835C214.29 164.425 214.51 163.86 214.569 163.141L215.449 151.701H227.769V165.451H229.639V170.621H226.999L226.559 167.101H214.679L214.239 170.621H211.599V165.451H212.699ZM217.649 163.141C217.62 163.523 217.524 163.86 217.363 164.153C217.202 164.447 217.026 164.689 216.835 164.879C216.615 165.114 216.373 165.305 216.109 165.451H224.579V153.351H218.419L217.649 163.141ZM235.251 153.351V158.411H243.281V160.061H235.251V165.451H245.481V167.101H232.061V151.701H245.481V153.351H235.251ZM258.131 164.901H258.351L264.071 151.701H268.801V167.101H265.611V154.781H265.391L260.111 167.101H256.371L251.091 154.781H250.871V167.101H247.681V151.701H252.411L258.131 164.901ZM284.522 167.101V154.561H284.302L276.052 167.101H271.872V151.701H275.062V164.241H275.282L283.532 151.701H287.712V167.101H284.522ZM290.14 167.101L293.77 161.909C292.67 161.484 291.826 160.868 291.24 160.061C290.653 159.255 290.36 158.265 290.36 157.091C290.36 156.241 290.521 155.485 290.844 154.825C291.166 154.151 291.628 153.586 292.23 153.131C292.831 152.662 293.564 152.31 294.43 152.075C295.31 151.826 296.3 151.701 297.4 151.701H305.32V167.101H302.13V162.481H297.4H297.004L293.77 167.101H290.14ZM297.4 153.351C296.241 153.351 295.346 153.659 294.716 154.275C294.085 154.877 293.77 155.815 293.77 157.091C293.77 158.367 294.085 159.313 294.716 159.929C295.346 160.531 296.241 160.831 297.4 160.831H302.13V153.351H297.4Z"
											fill="white"
										/>
										<path
											d="M313.234 128.437H320.17V145H311.477V136.209H277.63V145H269.398V128.437H278.748C278.883 128.266 279.109 127.846 279.109 127.233V84.0205H313.234V128.437ZM287.803 128.437H304.541V91.3311H287.803V128.437Z"
											fill="#0096ed"
										/>
										<path
											d="M237.858 113.975L253.671 105.838V84.0202H262.827V135.746H253.671V115.044L237.858 123.181V135.746H229.164V83.5576H237.858V113.975Z"
											fill="#0096ed"
										/>
										<path
											d="M252.274 85.1362L252.132 85.2664L246.121 90.8183L245.996 90.9349L245.87 90.8183L239.859 85.2664L239.717 85.1362L242.759 82.0928L245.996 85.3314L249.232 82.0928L252.274 85.1362Z"
											fill="#0096ed"
										/>
										<path
											d="M209.657 84.4443C212.332 84.6876 214.192 85.9907 215.367 87.5361C216.495 89.0186 216.982 90.7 217.09 91.8818L217.099 91.9756V105.583L217.09 105.677C216.607 110.99 212.113 113.401 210.016 113.974L209.748 114.047H193.979V106.645H207.619C208.102 106.645 208.407 106.557 208.59 106.475C208.77 106.393 208.887 106.292 208.972 106.188C209.168 105.949 209.237 105.632 209.237 105.487V93.458C209.237 92.602 208.993 92.1966 208.849 92.0215C208.772 91.9292 208.699 91.8729 208.647 91.8389H193.747C193.168 91.8389 192.875 91.9464 192.751 92.0107C192.643 92.0668 192.605 92.1186 192.58 92.1631C192.545 92.2268 192.506 92.3392 192.494 92.5078C192.482 92.6789 192.502 92.8439 192.529 92.9531L192.591 93.2021V127.233C192.591 128.097 192.835 128.339 192.854 128.358C192.872 128.376 192.89 128.384 192.899 128.39H207.619C208.471 128.39 208.978 128.107 209.237 127.9V118.303H217.099V128.621C217.099 130.688 215.997 132.305 214.932 133.375C213.855 134.457 212.59 135.217 211.701 135.612L211.298 135.792H192.154L191.952 135.752C187.497 134.86 185.335 131.955 184.811 130.118L184.73 129.838V91.1455C184.73 89.1369 185.697 87.5976 186.724 86.5654C187.734 85.5499 188.924 84.8905 189.78 84.5693L190.133 84.4365H209.563L209.657 84.4443Z"
											fill="#0096ed"
										/>
										<path
											d="M168.805 83.5449C170.295 83.7803 172.524 84.5079 174.386 85.9316C176.253 87.3595 177.76 89.4957 177.76 92.5332V92.5352L177.297 130.011V130.032L177.292 130.054C176.818 132.11 174.543 136.224 169.236 136.224H153.314V128.421H168.216C168.268 128.345 168.342 128.206 168.409 127.993C168.499 127.71 168.573 127.306 168.573 126.77V92.5332C168.573 92.3339 168.512 92.0301 168.334 91.7822C168.163 91.5446 167.876 91.3448 167.387 91.3447H153.145C153.014 91.519 152.79 91.9619 152.79 92.6592V157.043H144.066V91.1318H144.068C144.148 89.8634 144.667 87.9705 145.974 86.3906C147.287 84.8027 149.386 83.542 152.59 83.542H168.789L168.805 83.5449Z"
											fill="#0096ed"
										/>
										<path
											d="M258.939 30.5361V77.7279H255.24V33.7748H234.432V72.6386C234.432 74.4892 233.045 77.2652 228.883 77.7279H223.797V74.4892H228.421C231.195 74.0266 230.733 72.6386 230.733 69.8626V30.5361H258.939Z"
											fill="white"
										/>
										<path
											d="M215.478 30.0732V77.265H211.779V33.3119H190.971V72.1757C190.971 74.0263 189.584 76.8023 185.422 77.265H180.336V74.0263H184.96C187.734 73.5637 187.272 72.1757 187.272 69.3997V30.0732H215.478Z"
											fill="white"
										/>
										<path
											d="M166.75 29.5947C169.345 29.5947 170.926 30.4237 171.841 31.8867C172.741 33.3269 172.97 35.3446 172.97 37.6602V37.7539C172.97 37.8153 172.969 37.9065 172.969 38.0254C172.968 38.2631 172.966 38.6119 172.965 39.0566C172.962 39.9467 172.957 41.2216 172.952 42.7578C172.942 45.8301 172.927 49.9508 172.913 54.1436C172.885 62.5296 172.856 71.2042 172.856 72.3604C172.857 73.5432 172.621 74.517 172.007 75.3154C171.395 76.1113 170.428 76.7076 169.021 77.1768C168.65 77.3003 168.073 77.3878 167.364 77.4512C166.65 77.515 165.785 77.5554 164.829 77.5771C162.917 77.6206 160.63 77.5911 158.433 77.5332C156.234 77.4753 154.123 77.3887 152.562 77.3164C151.781 77.2802 151.138 77.2481 150.689 77.2246C150.466 77.2129 150.29 77.2028 150.171 77.1963C150.111 77.193 150.065 77.1912 150.034 77.1895C150.019 77.1886 150.007 77.187 149.999 77.1865H149.987L149.98 77.1855C147.885 76.9948 146.487 75.9986 145.598 74.8291C144.713 73.6657 144.331 72.3334 144.251 71.4531L144.25 71.4434V58.0088L144.251 57.999C144.632 53.8086 148.212 51.821 149.946 51.3477L149.973 51.3398H163.608V54.9785H151.849C150.424 54.9785 149.558 55.4955 149.044 56.1201C148.523 56.753 148.35 57.5157 148.35 58.0176V70.0469C148.35 72.522 149.8 73.402 150.485 73.5479H165.721C166.627 73.5478 167.257 73.4056 167.697 73.1855C168.132 72.9679 168.389 72.6698 168.544 72.334C168.701 71.9928 168.757 71.6036 168.771 71.2031C168.786 70.7902 168.758 70.4189 168.758 70.0469C168.758 69.3528 168.767 60.9087 168.775 52.6387C168.78 48.5038 168.784 44.4123 168.787 41.3545C168.789 39.8255 168.79 38.5543 168.791 37.666C168.792 37.222 168.792 36.8732 168.792 36.6357C168.792 36.5173 168.793 36.4265 168.793 36.3652V36.2676C168.831 34.6861 168.389 33.9647 167.779 33.6113C167.463 33.4281 167.082 33.3322 166.655 33.2832C166.227 33.2341 165.768 33.2334 165.294 33.2334H152.312C152.078 33.2334 151.836 33.226 151.597 33.2188C151.356 33.2115 151.117 33.2051 150.882 33.2051C150.41 33.2051 149.969 33.234 149.592 33.3418C149.219 33.4485 148.916 33.6294 148.703 33.9297C148.489 34.2324 148.35 34.6792 148.35 35.3467V42.9492H144.25V35.0664C144.251 31.5173 147.136 29.5947 149.538 29.5947H166.75Z"
											fill="white"
										/>
										<path
											d="M122.998 157.306H115.137L114.674 32.3866L65.6602 0.462769H173.399L122.998 32.3866V157.306Z"
											fill="#0096ed"
										/>
										<path
											d="M93.8667 36.088C93.7126 34.3915 92.387 30.9061 88.3179 30.536H69.3593C68.1263 30.9987 65.6602 32.5717 65.6602 35.1627V73.5638C65.9684 74.6433 67.5098 76.9875 71.2089 77.7277H89.7049C91.0921 77.1109 93.8665 75.2294 93.8665 72.6384V67.5491H90.1673V72.6384C89.859 73.2553 88.6876 74.4891 86.4681 74.4891H71.6713C70.9007 74.4891 69.3594 73.8414 69.3596 71.2505V37.476C69.0513 36.2422 69.2671 33.7747 72.5964 33.7747H87.8555C88.6262 33.9289 90.1675 34.8851 90.1675 37.476V49.5052C90.1675 50.5848 89.4277 52.7439 86.4683 52.7439H74.9084V55.9825H88.3179C90.0134 55.5199 93.4968 53.5767 93.8667 49.5052V36.088Z"
											fill="white"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M47.656 0.0253019V0.0198801H52.2799V77.7474H47.656V3.32811L29.3515 53.1648L29.4752 53.2262H29.3289L29.3153 53.2642L29.2124 53.2262H23.0675L22.9646 53.2642L22.951 53.2262H22.8047L22.9276 53.1648L4.62399 3.32811V77.7474H0V0.0198801H4.62399V0.0253019L7.42637 0L7.40109 0.0280129L26.14 51.0458L44.8789 0.0280129L44.8536 0L47.656 0.0253019ZM26.1327 52.0976L26.14 52.1003L26.1463 52.0976L26.14 52.0949L26.1327 52.0976Z"
											fill="white"
										/>
									</svg>
								</div>
								<div class="text-23">{{ text23 }}</div>
							</div>
							<div class="footer-center">
								<div class="footer-social">
									<group461 />
									<group463 />
									<div class="group-462">
										<div class="text-13 poppins-semi-bold-white-22px">
											{{ text13 }}
										</div>
										<a href="mailto:project@metall-trade.ru" target="_blank">
											<div
												class="projectmetall-traderu poppins-normal-boulder-22px"
											>
												{{ projectMetallTradeRu }}
											</div> </a
										><a href="tel:+74951362515" target="_blank">
											<div class="phone poppins-normal-boulder-22px">
												{{ phone }}
											</div> </a
										><a href="https://project.metall-trade.ru/" target="_blank">
											<p class="text-12-1 poppins-normal-boulder-22px">
												{{ text12 }}
											</p>
										</a>
									</div>
								</div>
							</div>
							<div class="footer-right">
								<div class="map-section">
									<iframe
										src="https://yandex.ru/map-widget/v1/?ll=37.681245,55.723228&z=17&pt=37.681245,55.723228,pm2rdm"
										width="100%"
										height="100%"
										frameborder="0"
									></iframe>
								</div>
							</div>
						</div>

						<p class="copyright poppins-normal-boulder-22px">
							<span class="span-1 poppins-normal-boulder-22px">{{
								spanText19
							}}</span
							><span class="span1-3 poppins-normal-boulder-22px">{{
								spanText20
							}}</span
							><span class="span-1 poppins-normal-boulder-22px">{{
								spanText21
							}}</span>
						</p>
					</footer>
				</div>
			</div>
		</div>
	</div>
	<!-- Кнопка прокрутки наверх -->
	<ScrollToTop />
	<!-- Плавающая кнопка быстрой связи -->
	<FloatingActionButton />
</template>

<script>
import {
	defineComponent,
	ref,
	computed,
	onMounted,
	onUnmounted,
	nextTick,
} from 'vue'
import Group58 from './Group58'
import Group582 from './Group582'
import Group456 from './Group456'
import Group455 from './Group455'
import ButtonSeeAll from './ButtonSeeAll'
import X5332 from './X5332'
import Group460 from './Group460'
import Group461 from './Group461'
import Group463 from './Group463'
import ScrollToTop from './ScrollToTop'
import SplashAnimate from './SplashAnimate'
import FloatingActionButton from './FloatingActionButton'
import Tooltip from './Tooltip'

export default defineComponent({
	name: 'X9',
	components: {
		Group58,
		Group582,
		Group456,
		Group455,
		ButtonSeeAll,
		X5332,
		Group460,
		Group461,
		Group463,
		ScrollToTop,
		SplashAnimate,
		FloatingActionButton,
		Tooltip,
	},
	props: {
		group452: { type: String, default: '' },
		text108: { type: String, default: '' },
		text109: { type: String, default: '' },
		group6: { type: String, default: '' },
		text106: { type: String, default: '' },
		text107: { type: String, default: '' },
		din: { type: String, default: '' },
		text104: { type: String, default: '' },
		text105: { type: String, default: '' },
		ellipse: { type: String, default: '' },
		text110: { type: String, default: '' },
		text111: { type: String, default: '' },
		text112: { type: String, default: '' },
		text115: { type: String, default: '' },
		text116: { type: String, default: '' },
		text118: { type: String, default: '' },
		text117: { type: String, default: '' },
		text119: { type: String, default: '' },
		text120: { type: String, default: '' },
		text113: { type: String, default: '' },
		text114: { type: String, default: '' },
		text121: { type: String, default: '' },
		image1: { type: String, default: '' },
		address1: { type: String, default: '' },
		text101: { type: String, default: '' },
		spanText1: { type: String, default: '' },
		spanText2: { type: String, default: '' },
		text102: { type: String, default: '' },
		address2: { type: String, default: '' },
		text103: { type: String, default: '' },
		text_Label1: { type: String, default: '' },
		text95: { type: String, default: '' },
		text96: { type: String, default: '' },
		text97: { type: String, default: '' },
		text98: { type: String, default: '' },
		hr: { type: String, default: '' },
		text_Label2: { type: String, default: '' },
		group80: { type: String, default: '' },
		text99: { type: String, default: '' },
		text100: { type: String, default: '' },
		text89: { type: String, default: '' },
		spanText3: { type: String, default: '' },
		spanText4: { type: String, default: '' },
		rectangle19: { type: String, default: '' },
		group23: { type: String, default: '' },
		text91: { type: String, default: '' },
		text92: { type: String, default: '' },
		text93: { type: String, default: '' },
		text94: { type: String, default: '' },
		spanText5: { type: String, default: '' },
		spanText6: { type: String, default: '' },
		text57: { type: String, default: '' },
		text58: { type: String, default: '' },
		spanText7: { type: String, default: '' },
		spanText8: { type: String, default: '' },
		spanText9: { type: String, default: '' },
		text60: { type: String, default: '' },
		text61: { type: String, default: '' },
		maskGroup1: { type: String, default: '' },
		maskGroup2: { type: String, default: '' },
		text62: { type: String, default: '' },
		text63: { type: String, default: '' },
		group641: { type: String, default: '' },
		a: { type: String, default: '' },
		group631: { type: String, default: '' },
		text64: { type: String, default: '' },
		group65: { type: String, default: '' },
		text65: { type: String, default: '' },
		group66: { type: String, default: '' },
		text66: { type: String, default: '' },
		group70: { type: String, default: '' },
		text67: { type: String, default: '' },
		text68: { type: String, default: '' },
		text69: { type: String, default: '' },
		text70: { type: String, default: '' },
		spanText10: { type: String, default: '' },
		spanText11: { type: String, default: '' },
		group122: { type: String, default: '' },
		text74: { type: String, default: '' },
		text75: { type: String, default: '' },
		maskGroup3: { type: String, default: '' },
		text76: { type: String, default: '' },
		group86: { type: String, default: '' },
		spanText12: { type: String, default: '' },
		spanText13: { type: String, default: '' },
		spanText14: { type: String, default: '' },
		text72: { type: String, default: '' },
		text77: { type: String, default: '' },
		spanText15: { type: String, default: '' },
		spanText16: { type: String, default: '' },
		text79: { type: String, default: '' },
		text80: { type: String, default: '' },
		maskGroup4: { type: String, default: '' },
		maskGroup5: { type: String, default: '' },
		maskGroup6: { type: String, default: '' },
		maskGroup7: { type: String, default: '' },
		number1: { type: String, default: '' },
		number2: { type: String, default: '' },
		number3: { type: String, default: '' },
		number4: { type: String, default: '' },
		group95: { type: String, default: '' },
		text83: { type: String, default: '' },
		text84: { type: String, default: '' },
		group642: { type: String, default: '' },
		group632: { type: String, default: '' },
		group101: { type: String, default: '' },
		group57: { type: String, default: '' },
		group99: { type: String, default: '' },
		text85: { type: String, default: '' },
		text86: { type: String, default: '' },
		text87: { type: String, default: '' },
		text88: { type: String, default: '' },
		spanText17: { type: String, default: '' },
		spanText18: { type: String, default: '' },
		text81: { type: String, default: '' },
		text54: { type: String, default: '' },
		text53: { type: String, default: '' },
		group401: { type: String, default: '' },
		text55: { type: String, default: '' },
		CqZ22j: { type: String, default: '' },
		hyMyEz: { type: String, default: '' },
		group4571: { type: String, default: '' },
		vIqT8D: { type: String, default: '' },
		B2cUJU: { type: String, default: '' },
		group4572: { type: String, default: '' },
		wsuwVx: { type: String, default: '' },
		vT82Fp: { type: String, default: '' },
		group4573: { type: String, default: '' },
		text47: { type: String, default: '' },
		JPDgjQ: { type: String, default: '' },
		x01FWBT: { type: String, default: '' },
		group4574: { type: String, default: '' },
		x9KS2d1: { type: String, default: '' },
		YidcRU: { type: String, default: '' },
		group4575: { type: String, default: '' },
		e29FLh: { type: String, default: '' },
		x8usXG1: { type: String, default: '' },
		group4576: { type: String, default: '' },
		text52: { type: String, default: '' },
		text_Label3: { type: String, default: '' },
		text_Label4: { type: String, default: '' },
		maskGroup8: { type: String, default: '' },
		text35: { type: String, default: '' },
		text36: { type: String, default: '' },
		address3: { type: String, default: '' },
		text42: { type: String, default: '' },
		text41: { type: String, default: '' },
		text40: { type: String, default: '' },
		text39: { type: String, default: '' },
		text38: { type: String, default: '' },
		text37: { type: String, default: '' },
		group402: { type: String, default: '' },
		metallTradeRu: { type: String, default: '' },
		address4: { type: String, default: '' },
		text31: { type: String, default: '' },
		text32: { type: String, default: '' },
		text34: { type: String, default: '' },
		spanText19: { type: String, default: '' },
		spanText20: { type: String, default: '' },
		spanText21: { type: String, default: '' },
		text13: { type: String, default: '' },
		projectMetallTradeRu: { type: String, default: '' },
		phone: { type: String, default: '' },
		text12: { type: String, default: '' },
		mapMakerRussiaMoscow115088Standard: { type: String, default: '' },
		text23: { type: String, default: '' },
		text24: { type: String, default: '' },
		image2: { type: String, default: '' },
		group58Props: { type: Object, default: () => ({}) },
		group582Props: { type: Object, default: () => ({}) },
		buttonSeeAllProps: { type: Object, default: () => ({}) },
		x53321Props: { type: Object, default: () => ({}) },
		x53322Props: { type: Object, default: () => ({}) },
		group460Props: { type: Object, default: () => ({}) },
	},
	setup() {
		// ========== СОСТОЯНИЯ ==========
		const isLoading = ref(true)

		// ========== СЛАЙДЕР ОТЗЫВОВ ==========
		const currentReviewIndex = ref(0)

		// Массив фейковых отзывов
		const reviews = [
			{
				image:
					'/assets/cdn-animaapp/mask-group-16.png',
				text: '"Благодарю за качественное обучение! Курс по 1С и Битрикс значительно повысил мои навыки. Система обучения МеталлТрейд - это то, чего не хватало нашему отделу"',
				name: 'Анна Петрова',
				info: '15 отзывов в Яндекс',
			},
			{
				image:
					'https://yt3.googleusercontent.com/ytc/AIdro_mrwS_2_SyW4hmnbpCLRDNvhfrzsGDorAzq5IrEZLVkmQ=s900-c-k-c0x00ffffff-no-rj',
				text: '"Отличная платформа для корпоративного обучения! Особенно понравились интерактивные задания и возможность отслеживать прогресс. Рекомендую всем коллегам!"',
				name: 'Дмитрий Соколов',
				info: '23 отзыва в Яндекс',
			},
			{
				image:
					'https://img.grouponcdn.com/deal/5QaZaaYSP8EL6LbDXwMC/1n-2048x1229/v1/t2100x1260.webp',
				text: '"Прошла курс по стандартам металлопроката - материал структурирован идеально. Преподаватели всегда на связи, отвечают на вопросы быстро и подробно. Спасибо!"',
				name: 'Елена Морозова',
				info: '18 отзывов в Яндекс',
			},
			{
				image:
					'https://t4.ftcdn.net/jpg/01/53/53/51/360_F_153535168_QoozEUnNBeoVWD2DTRlJKq1TLx7CT6sj.jpg',
				text: '"Удобный интерфейс, качественный контент, профессиональные преподаватели. Обучение в МеталлТрейд Академии помогло мне получить повышение. Очень доволен!"',
				name: 'Игорь Волков',
				info: '31 отзыв в Яндекс',
			},
			{
				image:
					'https://static.tildacdn.com/tild6639-3839-4363-b236-353763383235/odliczanie-vat.jpg',
				text: '"Система тестирования и сертификации на высшем уровне. Получила сертификат, который признаётся в отрасли. Буду продолжать обучение на других курсах!"',
				name: 'Мария Кузнецова',
				info: '12 отзывов в Яндекс',
			},
		]

		// Computed свойство для текущего отзыва
		const currentReview = computed(() => reviews[currentReviewIndex.value])

		// Функция переключения на следующий отзыв
		const nextReview = () => {
			currentReviewIndex.value = (currentReviewIndex.value + 1) % reviews.length
		}

		// ========== УТИЛИТЫ ==========

		// Debounce функция для оптимизации scroll events
		const debounce = (func, wait) => {
			let timeout
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout)
					func(...args)
				}
				clearTimeout(timeout)
				timeout = setTimeout(later, wait)
			}
		}

		// Проверка prefers-reduced-motion
		const prefersReducedMotion = () => {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches
		}

		// ========== 1. ПЛАВНАЯ ПРОКРУТКА ==========

		const setupSmoothScroll = () => {
			// Добавляем CSS scroll-behavior
			document.documentElement.style.scrollBehavior = prefersReducedMotion()
				? 'auto'
				: 'smooth'

			// Обработчик для якорных ссылок
			const handleAnchorClick = e => {
				const target = e.target.closest('a[href^="#"]')
				if (!target) return

				const href = target.getAttribute('href')
				if (!href || href === '#') return

				e.preventDefault()
				const targetElement = document.querySelector(href)
				if (targetElement) {
					targetElement.scrollIntoView({
						behavior: prefersReducedMotion() ? 'auto' : 'smooth',
						block: 'start',
					})
				}
			}

			document.addEventListener('click', handleAnchorClick)
			return () => document.removeEventListener('click', handleAnchorClick)
		}

		// ========== 5. SCROLL REVEAL АНИМАЦИИ ==========

		const setupScrollReveal = () => {
			const revealElements = []

			const observerOptions = {
				root: null,
				rootMargin: '0px',
				threshold: 0.1,
			}

			const observerCallback = entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('revealed')
						// Отключаем наблюдение после первого появления
						observer.unobserve(entry.target)
					}
				})
			}

			const observer = new IntersectionObserver(
				observerCallback,
				observerOptions
			)

			nextTick(() => {
				// Находим элементы для анимации
				const selectors = [
					'.group-454',
					'.group-457',
					'.group-458',
					'.group-454-1',
					'.group-457-1',
					'.group-457-2',
					'.group-458-1',
					'.x3-1',
					'.x2',
					'.x1',
					'.x-12',
					'.x-14',
				]

				selectors.forEach(selector => {
					const elements = document.querySelectorAll(selector)
					elements.forEach(el => {
						el.classList.add('reveal-element')
						observer.observe(el)
						revealElements.push(el)
					})
				})
			})

			return () => {
				observer.disconnect()
				revealElements.forEach(el => {
					el.classList.remove('reveal-element', 'revealed')
				})
			}
		}

		// ========== 8. ПАРАЛЛАКС ЭФФЕКТ ==========

		const setupParallax = () => {
			if (prefersReducedMotion()) return () => {}

			const handleParallax = () => {
				const scrolled = window.scrollY
				const parallaxElements = document.querySelectorAll('.parallax-element')

				parallaxElements.forEach(el => {
					const speed = el.dataset.parallaxSpeed || 0.5
					const yPos = -(scrolled * speed)
					el.style.transform = `translateY(${yPos}px)`
				})
			}

			const debouncedParallax = debounce(handleParallax, 50)
			window.addEventListener('scroll', debouncedParallax, { passive: true })

			return () => window.removeEventListener('scroll', debouncedParallax)
		}

		// ========== 16. SNAP SCROLLING (АВТОПРОКРУТКА К СЕКЦИЯМ) ==========

		const _setupSnapScrolling = () => {
			// Проверка prefers-reduced-motion
			const prefersReducedMotion = () => {
				return window.matchMedia('(prefers-reduced-motion: reduce)').matches
			}

			if (prefersReducedMotion()) {
				return () => {} // Отключаем snap scrolling для пользователей с prefers-reduced-motion
			}

			// Селекторы секций для snap
			const sectionSelectors = [
				'.view-1',
				'.view-2',
				'.view-3',
				'.view-4',
				'.view-5',
				'.view-6',
				'.view-8',
				'.view-9',
				'.view-10',
			]

			let scrollTimeout = null
			let _isScrolling = false
			let isManualScroll = false // Флаг для отслеживания клика по навигации

			// Функция для поиска ближайшей секции
			const findNearestSection = () => {
				const sections = []
				sectionSelectors.forEach(selector => {
					const elements = document.querySelectorAll(selector)
					elements.forEach(el => sections.push(el))
				})

				if (sections.length === 0) return null

				const scrollPosition = window.scrollY + window.innerHeight / 2
				let nearestSection = sections[0]
				let minDistance = Math.abs(
					sections[0].getBoundingClientRect().top +
						window.scrollY -
						scrollPosition
				)

				sections.forEach(section => {
					const sectionTop =
						section.getBoundingClientRect().top + window.scrollY
					const distance = Math.abs(sectionTop - scrollPosition)

					if (distance < minDistance) {
						minDistance = distance
						nearestSection = section
					}
				})

				return nearestSection
			}

			// Обработчик прокрутки колёсиком
			const handleWheel = () => {
				if (isManualScroll) return // Не срабатывает при клике на навигацию

				_isScrolling = true

				// Очищаем предыдущий таймер
				if (scrollTimeout) {
					clearTimeout(scrollTimeout)
				}

				// Устанавливаем новый таймер (debounce 400ms)
				scrollTimeout = setTimeout(() => {
					const nearestSection = findNearestSection()

					if (nearestSection) {
						nearestSection.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						})
					}

					_isScrolling = false
				}, 400)
			}

			// Отслеживание кликов по навигации
			const handleNavigationClick = () => {
				isManualScroll = true
				setTimeout(() => {
					isManualScroll = false
				}, 1000) // Отключаем snap на 1 секунду после клика
			}

			// Добавляем обработчики
			window.addEventListener('wheel', handleWheel, { passive: true })

			// Отслеживаем клики по якорным ссылкам
			const navLinks = document.querySelectorAll('a[href^="#"]')
			navLinks.forEach(link => {
				link.addEventListener('click', handleNavigationClick)
			})

			// Cleanup функция
			return () => {
				window.removeEventListener('wheel', handleWheel)
				navLinks.forEach(link => {
					link.removeEventListener('click', handleNavigationClick)
				})
				if (scrollTimeout) {
					clearTimeout(scrollTimeout)
				}
			}
		}

		// ========== 17. АНИМАЦИЯ СЧЁТЧИКОВ ==========

		const animateCounter = (element, target, duration = 2000) => {
			const start = 0
			const increment = target / (duration / 16) // 60 FPS
			let current = start

			const timer = setInterval(() => {
				current += increment
				if (current >= target) {
					element.textContent = Math.round(target)
					clearInterval(timer)
				} else {
					element.textContent = Math.round(current)
				}
			}, 16)
		}

		const setupCounterAnimations = () => {
			const observerOptions = {
				root: null,
				rootMargin: '0px',
				threshold: 0.5,
			}

			const observerCallback = entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const element = entry.target
						const targetValue = parseInt(
							element.dataset.counterTarget || element.textContent
						)
						if (!isNaN(targetValue)) {
							animateCounter(element, targetValue)
							observer.unobserve(element)
						}
					}
				})
			}

			const observer = new IntersectionObserver(
				observerCallback,
				observerOptions
			)

			nextTick(() => {
				// Находим элементы со счётчиками (например, в статистике)
				const counterElements = document.querySelectorAll('.counter-animate')
				counterElements.forEach(el => {
					observer.observe(el)
				})
			})

			return () => observer.disconnect()
		}

		// ========== LIFECYCLE HOOKS ==========

		onMounted(() => {
			// Имитация загрузки (для skeleton screens)
			setTimeout(() => {
				isLoading.value = false
			}, 500)

			// Инициализация всех улучшений
			const cleanupFunctions = []

			cleanupFunctions.push(setupSmoothScroll())
			cleanupFunctions.push(setupScrollReveal())
			cleanupFunctions.push(setupParallax())
			cleanupFunctions.push(setupCounterAnimations())

			// Добавляем класс parallax к header
			nextTick(() => {
				const header = document.querySelector('.header')
				if (header) {
					header.classList.add('parallax-element')
					header.dataset.parallaxSpeed = '0.3'
				}
			})

			// Сохраняем cleanup функции для onUnmounted
			window.__x9Cleanup = cleanupFunctions
		})

		onUnmounted(() => {
			// Очистка всех обработчиков
			if (window.__x9Cleanup) {
				window.__x9Cleanup.forEach(cleanup => cleanup())
				delete window.__x9Cleanup
			}

			// Восстанавливаем scroll-behavior
			document.documentElement.style.scrollBehavior = ''
		})

		return {
			isLoading,
			currentReview,
			nextReview,
		}
	},
})
</script>

<style>
/* Глобальные стили для оптимизации под 1920x1080 */
* {
	box-sizing: border-box;
}

/* ===== АДАПТИВНОЕ МАСШТАБИРОВАНИЕ ПОД РАЗНЫЕ РАЗРЕШЕНИЯ И МАСШТАБЫ БРАУЗЕРА ===== */
/* Дизайн создан для 1920px, поэтому нужно масштабирование для меньших разрешений */

/* Экраны ≤1366px (реальные мониторы 1366×768) */
@media (max-width: 1366px) {
	body {
		zoom: 0.711; /* 1366 ÷ 1920 = 0.711 */
	}

	/* Убираем центрирование и ограничиваем ширину контейнеров */
	.container-center-horizontal {
		justify-content: flex-start !important;
	}

	.u1075u1083u1072u1074u1085u1072u1103-u1074u1072u1088u1080u1072u1085u1090-9,
	.x7 {
		max-width: 100% !important;
	}
}

/* Экраны 1367-1600px (включает FullHD с масштабом 125%: 1920÷1.25=1536px) */
@media (min-width: 1367px) and (max-width: 1600px) {
	body {
		zoom: 0.85; /* Компромисс между 0.711 и 1.0 для промежуточных разрешений */
	}

	/* Убираем центрирование и ограничиваем ширину контейнеров */
	.container-center-horizontal {
		justify-content: flex-start !important;
	}

	.u1075u1083u1072u1074u1085u1072u1103-u1074u1072u1088u1080u1072u1085u1090-9,
	.x7 {
		max-width: 100% !important;
	}
}

/* QHD 2560x1440 (15.6") — компенсация под 100% масштаб (как при 90%) */
/* При масштабе Windows 150% браузер видит ~1707px (2560/1.5) */
@media (min-width: 1601px) and (max-width: 1800px) {
	body {
		zoom: 0.9 !important;
	}
}

/* Экраны 1801-2300px - без дополнительного масштабирования */
@media (min-width: 1801px) and (max-width: 2300px) {
	body {
		zoom: 1.0 !important;
	}
}

/* QHD 2560x1440 с масштабом Windows 100% - увеличение до 150% */
/* При масштабе Windows 100% браузер видит полные 2560px */
@media (min-width: 2301px) and (max-width: 2880px) {
	body {
		zoom: 1.35 !important;
	}
}

/* Экраны >1600px (FullHD с масштабом 100% и больше) - без масштабирования */

body {
	margin: 0;
	padding: 0;
	overflow-x: hidden;
	overflow-y: auto;
	width: 100%;
	height: 100vh;
}

.u1075u1083u1072u1074u1085u1072u1103-u1074u1072u1088u1080u1072u1085u1090-9 {
	align-items: flex-start;
	background-color: var(--white);
	display: flex;
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	overflow: visible;
	min-height: 100vh;
}

.x7 {
	display: flex;
	flex-direction: column;
	min-height: 14372px;
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	position: relative;
}

.header {
	background-color: transparent;
	position: relative;
	width: 100%;
	max-width: 1920px;
	z-index: 1000;
	margin: 0 auto;
	/* Обеспечиваем, что header всегда поверх других элементов */
}

/* Стили для логотипа МеталлТрейд Академия */
.logo-container {
	position: absolute;
	top: 38px;
	left: 250px;
	z-index: 1001;
}

.company-logo {
	width: 200px;
	height: auto;
	display: block;
}

.group-452 {
	background-size: 100% 100%;
	height: 1071px;
	left: 0;
	position: absolute;
	top: 0;
	width: 1920px;
}

.view {
	display: flex;
	flex-direction: column;
	height: 605px;
	left: 792px;
	position: absolute;
	top: 216px;
	width: 922px;
}

.group-7 {
	height: 100px;
	position: relative;
	width: 357px;
}

.rectangle-6 {
	-webkit-backdrop-filter: blur(7.5px) brightness(100%);
	backdrop-filter: blur(7.5px) brightness(100%);
	background-color: var(--white-10);
	border-radius: 20px;
	height: 100px;
	left: 0;
	position: absolute;
	top: 0;
	width: 353px;
}

.text-108 {
	left: 83px;
	letter-spacing: 0.48px;
	line-height: 32px;
	position: absolute;
	top: 17px;
	width: 74px;
}

.text-109 {
	left: 82px;
	right: 16px;
	letter-spacing: 0.4px;
	line-height: 24px;
	position: absolute;
	top: 51px;
}

.group-6 {
	height: 50px;
	left: 15px;
	position: absolute;
	top: 26px;
	width: 50px;
}

.group-10 {
	height: 110px;
	margin-left: 528px;
	margin-top: 4px;
	position: relative;
	width: 374px;
}

.rectangle-6-1 {
	-webkit-backdrop-filter: blur(7.5px) brightness(100%);
	backdrop-filter: blur(7.5px) brightness(100%);
	background-color: var(--white-10);
	border-radius: 20px;
	height: 110px;
	left: 0;
	position: absolute;
	top: 0;
	width: 370px;
}

.text-106 {
	left: 100px;
	letter-spacing: 0.48px;
	line-height: 32px;
	position: absolute;
	text-shadow: 0px 4px 14.2px #636363;
	top: 20px;
	white-space: nowrap;
}

.text-107 {
	left: 100px;
	right: 16px;
	letter-spacing: 0.4px;
	line-height: 24px;
	position: absolute;
	text-shadow: 0px 4px 14.2px #636363;
	top: 54px;
}

.group-6-1 {
	background-color: var(--azure-radiance-5);
	border-radius: 8px;
	height: 50px;
	left: 26px;
	position: absolute;
	top: 30px;
	width: 50px;
}

.email-2-1 {
	height: 30px;
	left: 36px;
	position: absolute;
	top: 40px;
	width: 30px;
}

.group-11 {
	background-color: var(--azure-radiance-5);
	border-radius: 10px;
	display: flex;
	height: 20px;
	justify-content: center;
	left: 334px;
	position: absolute;
	top: 21px;
	width: 20px;
}

.vector-4 {
	height: 9.52px;
	margin-left: 1px;
	margin-top: 6px;
	width: 11px;
}

.group-13 {
	height: 164px;
	margin-left: 485px;
	margin-top: 227px;
	position: relative;
	width: 441px;
}

.rectangle-6-2 {
	-webkit-backdrop-filter: blur(7.5px) brightness(100%);
	backdrop-filter: blur(7.5px) brightness(100%);
	background-color: var(--white-10);
	border-radius: 20px;
	height: 164px;
	left: 0;
	position: absolute;
	top: 0;
	width: 437px;
}

.din {
	left: 80px;
	letter-spacing: 0.48px;
	line-height: 32px;
	position: absolute;
	text-shadow: 0px 4px 11.2px #636363;
	top: 18px;
	white-space: nowrap;
}

.text-104 {
	left: 76px;
	letter-spacing: 0.4px;
	line-height: 24px;
	position: absolute;
	text-shadow: 0px 4px 11.2px #636363;
	top: 51px;
	white-space: nowrap;
}

.group-12 {
	height: 50px;
	left: 124px;
	position: absolute;
	top: 100px;
	width: 191px;
}

.rectangle-3 {
	background-color: var(--azure-radiance-5);
	border-radius: 80px;
	height: 50px;
	left: 0;
	position: absolute;
	top: 0;
	width: 189px;
}

.text-105 {
	left: 15px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 12px;
}

.ellipse {
	height: 56px;
	left: 14px;
	object-fit: cover;
	position: absolute;
	top: 24px;
	width: 56px;
}

.ellipse-4 {
	background-color: #2ebb5e;
	border: 2px solid;
	border-color: #fbecd7;
	border-radius: 10px;
	height: 20px;
	left: 51px;
	position: absolute;
	top: 63px;
	width: 20px;
}

.group-450 {
	display: flex;
	flex-direction: column;
	height: 430px;
	left: 268px;
	position: absolute;
	top: 331px;
	width: 595px;
}

.text-110 {
	color: var(--white);
	font-family: var(--font-family-poppins);
	font-size: 54px;
	font-weight: 700;
	height: 162px;
	letter-spacing: 0;
	line-height: normal;
	width: 478px;
}

.text-111 {
	color: var(--white);
	font-family: var(--font-family-nunito_sans);
	font-size: 24px;
	font-weight: 400;
	height: 114px;
	letter-spacing: 0;
	line-height: 38.4px;
	margin-top: 18px;
	width: 591px;
}

.group-449 {
	display: flex;
	margin-top: 56px;
	width: 380.56px;
}

.group-3 {
	height: 80px;
	position: relative;
	width: 382.56px;
  cursor: pointer;
}

.rectangle-3-1 {
	-webkit-backdrop-filter: blur(7.5px) brightness(100%);
	backdrop-filter: blur(7.5px) brightness(100%);
	background-color: var(--white-12);
	border-radius: 80px;
	height: 80px;
	left: 0;
	top: 0;
	width: 381px;

  position: relative;
	overflow: hidden;
  transition: all 0.3s ease;
}

.rectangle-3-1::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 0;
	height: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.3);
	transform: translate(-50%, -50%);
	transition: width 0.6s, height 0.6s;
}

.rectangle-3-1:hover::before {
	width: 390px;
	height: 390px;
}

.group-3:hover .rectangle-3-1 {
	box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);
}









.text-112 {
	color: var(--white);
	font-family: var(--font-family-poppins);
	font-size: 24px;
	font-weight: 600;
	left: calc(50% - 100px);
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 18px);
	width: 233px;
}

.group-447 {
	display: flex;
	gap: 44px;
	height: 51px;
	left: 501px;
	position: absolute;
	top: 41px;
	width: 1346px;
}

.group-446 {
	display: flex;
	gap: 40px;
	height: 34px;
	margin-top: 7px;
	width: 952px;
}

.text-115 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	width: 137px;
}

.text-116 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	margin-top: 1px;
	width: 152px;
}

.text-118 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	margin-top: 1px;
	width: 133px;
}

.text-117 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	margin-top: 1px;
	width: 68px;
}

.text-119 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	margin-top: 1px;
	width: 156px;
}

.text-120 {
	cursor: pointer;
	height: 33px;
	letter-spacing: 0.44px;
	line-height: normal;
	margin-top: 1px;
	width: 94px;
}

.group-445 {
	display: flex;
	gap: 18px;
	height: 51px;
	width: 350px;
}

.group-1 {
	cursor: pointer;
	height: 50px;
	position: relative;
	transition: all 0.1s ease;
	width: 152px;
}

.group-1:hover {
	transform: scale(1.1);
}

/* Улучшенная кнопка "Начать обучение" */
.start-learning-button {
	text-decoration: none;
	display: block;
	transition: all 0.3s ease;
}

.start-learning-button:hover {
	transform: translateY(-3px);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.start-learning-button:hover .rectangle-3-1 {
	background-color: var(--azure-radiance) !important;
	box-shadow: 0 0 20px rgba(0, 149, 236, 0.4);
}

.start-learning-button:active {
	transform: translateY(-1px);
}

.rectangle-2 {
	background: conic-gradient(
		from 90deg at 50% 31%,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 1) 100%
	);
	border-radius: 80px;
	box-shadow: 0px 20px 24px #63636308;
	cursor: pointer;
	height: 50px;
	left: 0;
	position: absolute;
	top: 0;
	width: 150px;
}

.text-113 {
	color: var(--chicago);
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-m);
	font-weight: 500;
	left: 40px;
	letter-spacing: 0.4px;
	line-height: normal;
	position: absolute;
	text-align: center; /* добавил */
	top: 10px;
	width: 69px;
}

.group-113 {
	height: 50px;
	margin-top: 1px;
	position: relative;
	width: 182px;
	transition: all 0.1s ease;
}

.group-113:hover {
	transform: scale(1.1);
}

.rectangle-2-1 {
	background-color: var(--white-12);
	border-radius: 80px;
	box-shadow: 0px 20px 24px #636363;
	cursor: pointer;
	height: 50px;
	left: 0;
	position: absolute;
	top: 0;
	width: 180px;
}

.text-114 {
	color: var(--white);
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-m);
	font-weight: 500;
	left: 50%; /* изменить */
	transform: translateX(-50%); /* добавить */
	letter-spacing: 0.4px;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 10px;
}

.x3 {
	aspect-ratio: 1.84;
	height: 110px;
	left: 268px;
	position: absolute;
	top: calc(50% - 498px);
	width: 204px;
}

.text-121 {
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	line-clamp: 1;
	align-items: flex-end;
	color: var(--white);
	display: -webkit-box;
	font-family: var(--font-family-prosto_one);
	font-size: 13px;
	font-weight: 400;
	height: 18px;
	justify-content: center;
	left: 100px;
	letter-spacing: 0;
	line-height: normal;
	overflow: hidden;
	position: absolute;
	text-overflow: ellipsis;
	top: calc(50% + 37px);
	width: 102px;
}

.image {
	aspect-ratio: 2.04;
	height: 99px;
	left: 0;
	position: absolute;
	top: 0;
	width: 202px;
}

.view-1 {
	height: 450px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 1300px;
	position: relative;
	width: min(1395px, calc(100% - 40px));
	max-width: 1395px;
}

.frame-55 {
	align-items: flex-start;
	display: flex;
	gap: 95px;
	height: 140px;
	left: 0;
	position: absolute;
	top: 273px;
	width: 1495px;
}

.frame {
	align-items: center;
	display: inline-flex;
	flex: 0 0 auto;
	flex-direction: column;
	position: relative;
}

.address {
	letter-spacing: 0;
	line-height: 96px;
	margin-top: -1px;
	position: relative;
	white-space: nowrap;
	width: fit-content;
}

.text-10-1 {
	letter-spacing: 0;
	line-height: 41.6px;
	position: relative;
	white-space: nowrap;
	width: fit-content;
}

.frame-49 {
	align-items: center;
	display: flex;
	flex-direction: column;
	position: relative;
	width: 900px;
}

.address-1 {
	align-items: center;
	align-self: stretch;
	display: flex;
	justify-content: center;
	line-height: 96px;
	margin-top: -1px;
	position: relative;
}

.span0 {
	letter-spacing: 0;
}

.span1 {
	letter-spacing: 1px;
}

.address-2 {
	letter-spacing: 0;
	line-height: 96px;
	margin-top: -1px;
	position: relative;
	width: 320px;
}

.text-103 {
	letter-spacing: 0;
	line-height: 41.6px;
	position: relative;
	width: 320px;
}

.frame-54 {
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 16px;
	height: 144px;
	left: calc(50% - 636px);
	position: absolute;
	top: calc(50% - 206px);
	width: 1266px;
}

.text_label {
	color: #2d2d2dbf;
	font-family: var(--font-family-arial-bold);
	font-size: 45px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: 72px;
	margin-left: -41.5px;
	margin-right: -41.5px;
	margin-top: -1px;
	position: relative;
	text-align: center;
	width: 1349px;
}

.view-2 {
	align-self: center;
	height: 665.19px;
	margin-top: 316px;
	position: relative;
	width: min(1316px, calc(100% - 40px));
	max-width: 1316px;
}

.text-95 {
	left: calc(50% - 201px);
	letter-spacing: 0;
	line-height: 72px;
	position: absolute;
	top: 0;
	white-space: nowrap;
}

.text-96 {
	left: 177px;
	letter-spacing: 0;
	line-height: 43.2px;
	position: absolute;
	top: 101px;
	width: 1073px;
}

.x3-1 {
	height: 402px;
	left: 912px;
	position: absolute;
	top: 263px;
	width: 404px;
}

.rectangle-1 {
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 0px 10px 60px #262c7514;
	height: 345px;
	left: 0;
	position: absolute;
	top: 57px;
	width: 400px;
}

.text-97 {
	left: 35px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 116px;
	white-space: nowrap;
	width: 330px;
}

.text-98 {
	left: 12px;
	letter-spacing: 0;
	line-height: 36px;
	position: absolute;
	top: 176px;
	width: 377px;
}

.group {
	background-color: var(--azure-radiance-2);
	border-radius: 50px/50.15px;
	box-shadow: 0px 10px 40px #363c880f;
	display: flex;
	height: 100px;
	left: 150px;
	position: absolute;
	top: 0;
	width: 100px;
}

.users-1 {
	height: 44.13px;
	margin-left: 23px;
	margin-top: 28.1px;
	position: relative;
	width: 55px;
}

.vector {
	height: 87.5%;
	left: 0;
	position: absolute;
	top: 6.25%;
	width: 100%;
}

.x2 {
	height: 402px;
	left: 455px;
	position: absolute;
	top: 263px;
	width: 406px;
}

.rectangle-15 {
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 0px 10px 60px #262c7514;
	height: 345px;
	left: 1px;
	position: absolute;
	top: 57px;
	width: 400px;
}

.hr {
	left: calc(50% - 203px);
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 116px;
	white-space: nowrap;
	width: 402px;
}

.text_label-1 {
	left: 18px;
	letter-spacing: 0;
	line-height: 36px;
	position: absolute;
	top: 176px;
	width: 367px;
}

.group-80 {
	height: 180px;
	left: 111px;
	position: absolute;
	top: -24px;
	width: 180px;
}

.x1 {
	height: 402px;
	left: 0;
	position: absolute;
	top: 263px;
	width: 404px;
}

.text-99 {
	left: 14px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 116px;
	width: 372px;
}

.text-100 {
	left: 24px;
	letter-spacing: 0;
	line-height: 36px;
	position: absolute;
	top: 176px;
	width: 352px;
}

.file-invoice-1 {
  
	background-image: url("@/assets/cdn-animaapp/file-invoice-1.svg");
	background-size: 100% 100%;
	height: 46.14px;
	margin-left: 34px;
	margin-top: 27.1px;
	width: 33px;
}

.view-3 {
	height: 708px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 220.8px;
	position: relative;
	width: min(1308px, calc(100% - 40px));
	max-width: 1308px;
}

.text-89 {
	left: 99px;
	letter-spacing: 0.48px;
	line-height: 43.2px;
	position: absolute;
	text-align: center;
	top: 99px;
	width: 1101px;
}

.text-90 {
	color: transparent;
	font-family: var(--font-family-poppins);
	font-size: 44px;
	font-weight: 600;
	left: 237px;
	letter-spacing: 0;
	line-height: 79.2px;
	position: absolute;
	text-align: center;
	top: 0;
	white-space: nowrap;
}

.span0-1 {
	color: var(--thunder);
}

.span1-1 {
	color: #00cbb8;
}

.group-22 {
	height: 403px;
	left: 0;
	position: absolute;
	top: 305px;
	width: 600px;
}

.rectangle-19 {
	height: 400px;
	left: 0;
	object-fit: cover;
	position: absolute;
	top: 3px;
	width: 600px;
}
.group-23 {
	background-color: #c4c4c4;
	background-position: 50% 50%;
	background-size: cover;
	border-radius: 20px;
	display: flex;
	height: 400px;
	left: 700px;
	position: absolute;
	top: 308px;
	width: 600px;
}

.rectangle-23 {
	background-color: #171b4073;
	border-radius: 20px;
	height: 400px;
	opacity: 0.6;
	width: 600px;
}

.text-91 {
	left: 124px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 440px;
}

.text-92 {
	left: 879px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 440px;
}

.group-20 {
	height: 80px;
	left: 159px;
	position: absolute;
	top: 505px;
	width: 285px;
}

.rectangle-24 {
	border: 1px solid;
	border-color: var(--white);
	border-radius: 80px;
	height: 80px;
	left: 0;
	position: absolute;
	top: 0;
	width: 283px;
}

.text-93 {
	left: 71px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 24px;
}

.group-21 {
	height: 80px;
	left: 859px;
	position: absolute;
	top: 505px;
	width: 285px;
}

.rectangle-24-1 {
	background-color: #0096ed;
	border-radius: 80px;
	height: 80px;
	left: 0;
	position: absolute;
	top: 0;
	width: 283px;
}

.text-94 {
	left: 47px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 24px;
}

.view-4 {
	align-self: center;
	height: 3993px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 215px;
	position: relative;
	width: min(1615px, calc(100% - 40px));
	max-width: 1615px;
}

.text-56 {
	color: transparent;
	font-family: var(--font-family-poppins);
	font-size: 40px;
	font-weight: 700;
	left: calc(50% - 228px);
	letter-spacing: 0;
	line-height: 72px;
	position: absolute;
	top: 0;
	white-space: nowrap;
}

.span1-2 {
	color: var(--azure-radiance);
}

.text-57 {
	color: var(--pale-sky);
	font-family: var(--font-family-poppins);
	font-size: 24px;
	font-weight: 400;
	left: calc(50% - 452px);
	letter-spacing: 0;
	line-height: 43.2px;
	position: absolute;
	text-align: center;
	top: 71px;
	white-space: nowrap;
}

.group-37 {
	height: 80px;
	left: 624px;
	position: absolute;
	top: 3913px;
	width: 365px;
}

.rectangle-31 {
	border: 1px solid;
	border-color: var(--azure-radiance);
	border-radius: 80px;
	height: 80px;
	left: 0;
	position: absolute;
	top: 0;
	width: 363px;
}

.text-58 {
	color: var(--azure-radiance);
	font-family: var(--font-family-nunito_sans);
	font-size: 24px;
	font-weight: 700;
	left: calc(50% - 154px);
	letter-spacing: 0.48px;
	line-height: 43.2px;
	position: absolute;
	text-align: center;
	top: 19px;
	white-space: nowrap;
}

.group-83 {
	height: 930px;
	left: 20px;
	position: absolute;
	top: 151px;
	width: 1593px;
}

.text-59 {
	left: 1001px;
	letter-spacing: 0;
	line-height: 64px;
	position: absolute;
	top: 164px;
	width: 595px;
}

.ellipse-19 {
	background-color: #5b61ea;
	border-radius: 132px;
	height: 264px;
	left: 666px;
	position: absolute;
	top: 387px;
	width: 264px;
}

.ellipse-20 {
	background-color: #f56565;
	border-radius: 15px;
	height: 30px;
	left: 578px;
	position: absolute;
	top: 598px;
	width: 30px;
}

.ellipse-21 {
	background-color: #33d8ef;
	border-radius: 15px;
	height: 30px;
	left: 223px;
	position: absolute;
	top: 8px;
	width: 30px;
}

.ellipse-22 {
	background-color: var(--shamrock-2);
	border-radius: 70px;
	height: 140px;
	left: 63px;
	position: absolute;
	top: 0;
	width: 140px;
}

.group-71 {
	height: 854px;
	left: 0;
	position: absolute;
	top: 76px;
	width: 955px;
}

.group-67 {
	-webkit-backdrop-filter: blur(40px) brightness(100%);
	backdrop-filter: blur(40px) brightness(100%);
	background-color: #f4f4f499;
	border-radius: 20px;
	height: 483px;
	left: 0;
	position: absolute;
	top: 0;
	width: 783px;
}

.rectangle-50 {
	-webkit-backdrop-filter: blur(40px) brightness(100%);
	backdrop-filter: blur(40px) brightness(100%);
	background-color: #e9e9e999;
	border-radius: 20px 20px 0px 0px;
	height: 34px;
	left: 0;
	position: absolute;
	top: 0;
	width: 783px;
}

.ellipse-16 {
	background-color: var(--sunglo);
	border-radius: 7px;
	height: 14px;
	left: 27px;
	position: absolute;
	top: 10px;
	width: 14px;
}

.ellipse-17 {
	background-color: var(--cream-can);
	border-radius: 7px;
	height: 14px;
	left: 51px;
	position: absolute;
	top: 10px;
	width: 14px;
}

.ellipse-18 {
	background-color: var(--pastel-green);
	border-radius: 7px;
	height: 14px;
	left: 75px;
	position: absolute;
	top: 10px;
	width: 14px;
}

.group-55 {
	height: 51px;
	left: 34px;
	position: absolute;
	top: 384px;
	width: 189px;
}

.rectangle-43 {
	background-color: var(--royal-blue);
	border-radius: 51.07px;
	box-shadow: 0px 8.51px 20.43px #3465e14c;
	height: 51px;
	left: 0;
	position: absolute;
	top: 0;
	width: 187px;
}

.text-60 {
	left: calc(50% - 82px);
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 11px;
	width: 164px;
  cursor: pointer;
}

.group-56 {
	height: 65px;
	left: 238px;
	position: absolute;
	top: 375px;
	width: 249px;
}

.rectangle-45 {
	background-color: #25e22e5c;
	border-radius: 51.07px;
	height: 65px;
	left: 0;
	position: absolute;
	top: 0;
	width: 247px;
}

.rectangle-44 {
	background-color: #44c94b;
	border-radius: 51.07px;
	box-shadow: 0px 8.51px 20.43px #c92e5d4c;
	height: 51px;
	left: 12px;
	position: absolute;
	top: 7px;
	width: 224px;
}

.text-61 {
	left: 40px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 17px;
	width: 171px;
  cursor: pointer;
}

.group-57 {
	height: 270px;
	left: 84px;
	position: absolute;
	top: 93px;
	width: 308px;
}

.mask-group {
	height: 344px;
	left: -39px;
	position: absolute;
	top: -23px;
	width: 386px;
}

.mask-group-1 {
	height: 263px;
	left: 0;
	position: absolute;
	top: 0;
	width: 308px;
}

.group-61 {
	height: 23px;
	left: 29px;
	position: absolute;
	top: 231px;
	width: 261px;
}

.rectangle-6-3 {
	-webkit-backdrop-filter: blur(5.55px) brightness(100%);
	backdrop-filter: blur(5.55px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 5.55px;
	height: 23px;
	left: 0;
	position: absolute;
	top: 0;
	width: 257px;
}

.rectangle-7 {
	background-color: var(--dodger-blue);
	border-radius: 5.55px;
	height: 17px;
	left: 23px;
	position: absolute;
	top: 3px;
	width: 110px;
}

.text-62 {
	left: 147px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 5px;
	width: 95px;
}

.text-63 {
	color: var(--white);
	font-family: var(--font-family-nunito_sans);
	font-size: 10px;
	font-weight: 600;
	left: 39px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 5px;
	width: 83px;
}

.group-64 {
	background-size: 100% 100%;
	box-shadow: 17px 17px 40px #0d0f1c1a;
	display: flex;
	height: 195px;
	left: 736px;
	position: absolute;
	top: 54px;
	width: 202px;
}

.group-59 {
	height: 26.26px;
	margin-left: 10.8px;
	margin-top: 158.2px;
	position: relative;
	width: 104.35px;
}

.rectangle-6-4 {
	-webkit-backdrop-filter: blur(6.73px) brightness(100%);
	backdrop-filter: blur(6.73px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 6.73px;
	height: 26px;
	left: 0;
	position: absolute;
	top: 0;
	width: 102px;
}

.a {
	color: var(--white);
	font-family: var(--font-family-nunito_sans);
	font-size: 13.5px;
	font-weight: 600;
	left: 22px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 9px);
	width: 73px;
}

.group-63 {
	background-size: 100% 100%;
	display: flex;
	height: 161px;
	left: 516px;
	position: absolute;
	top: 93px;
	width: 166px;
}

.group-60 {
	height: 22px;
	margin-left: 9.2px;
	margin-top: 130.2px;
	position: relative;
	width: 122px;
}

.rectangle-6-5 {
	-webkit-backdrop-filter: blur(5.55px) brightness(100%);
	backdrop-filter: blur(5.55px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 5.55px;
	height: 22px;
	left: 0;
	position: absolute;
	top: 0;
	width: 120px;
}

.text-64 {
	left: 18px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 3px;
	width: 97px;
}

.group-65 {
	background-size: 100% 100%;
	display: flex;
	height: 161px;
	left: 516px;
	position: absolute;
	top: 279px;
	width: 166px;
}

.group-61-1 {
	height: 22px;
	margin-left: 9.2px;
	margin-top: 130.4px;
	position: relative;
	width: 135px;
}

.rectangle-6-6 {
	-webkit-backdrop-filter: blur(5.55px) brightness(100%);
	backdrop-filter: blur(5.55px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 5.55px;
	height: 22px;
	left: 0;
	position: absolute;
	top: 0;
	width: 133px;
}

.text-65 {
	left: 18px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 7px);
	width: 102px;
}

.group-66 {
	background-size: 100% 100%;
	box-shadow: 20px 20px 40px #0d0f1c26;
	display: flex;
	height: 226px;
	left: 715px;
	position: absolute;
	top: 297px;
	width: 240px;
}

.group-62 {
	height: 30.39px;
	margin-left: 12.8px;
	margin-top: 183.1px;
	position: relative;
	width: 204.2px;
}

.rectangle-6-7 {
	-webkit-backdrop-filter: blur(8px) brightness(100%);
	backdrop-filter: blur(8px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 8px;
	height: 30px;
	left: 0;
	position: absolute;
	top: 0;
	width: 202px;
}

.text-66 {
	color: var(--white);
	font-family: var(--font-family-nunito_sans);
	font-size: var(--font-size-xxs);
	font-weight: 600;
	left: 34px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 10px);
	width: 159px;
}

.group-58 {
	display: flex;
	gap: 2px;
	height: 11px;
	left: 10px;
	position: absolute;
	top: 10px;
	width: 13px;
}

.rectangle-46 {
	background-color: var(--white);
	border-radius: 0.8px;
	height: 5.46px;
	margin-left: 0;
	margin-top: 5.5px;
	width: 3.05px;
}

.rectangle-47 {
	background-color: var(--white);
	border-radius: 0.8px;
	height: 8.18px;
	margin-top: 2.7px;
	width: 3.05px;
}

.rectangle-48 {
	background-color: var(--white);
	border-radius: 0.8px;
	height: 10.91px;
	margin-top: 0;
	width: 3.05px;
}

.group-70 {
	height: 625px;
	left: 428px;
	position: absolute;
	top: 229px;
	width: 161px;
}

.group-453 {
	height: 320px;
	left: 1000px;
	position: absolute;
	top: 331px;
	width: 596px;
}

.text-67 {
	left: 97px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 240px;
	width: 493px;
}

.ellipse-24 {
	background-color: var(--alabaster);
	border-radius: 31.53px/30px;
	box-shadow: 0px 15px 44px #0d0f1c1f;
	height: 60px;
	left: 0;
	position: absolute;
	top: 10px;
	width: 63px;
}

.ellipse-25 {
	background-color: var(--alabaster);
	border-radius: 31.53px/30px;
	box-shadow: 0px 15px 44px #0d0f1c1f;
	height: 60px;
	left: 0;
	position: absolute;
	top: 134px;
	width: 63px;
}

.ellipse-26 {
	background-color: var(--alabaster);
	border-radius: 31.53px/30px;
	box-shadow: 0px 15px 44px #0d0f1c1f;
	height: 60px;
	left: 0;
	position: absolute;
	top: 248px;
	width: 63px;
}

.text-68 {
	left: 97px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 0;
	width: 477px;
}

.group-72 {
	height: 26px;
	left: 18px;
	position: absolute;
	top: 27px;
	width: 28px;
}

.rectangle-51 {
	background-color: var(--thunder);
	border-radius: 2px;
	height: 12px;
	left: 1px;
	position: absolute;
	top: 0;
	width: 12px;
}

.rectangle-53 {
	background-color: var(--thunder);
	border-radius: 2px;
	height: 12px;
	left: 1px;
	position: absolute;
	top: 14px;
	width: 12px;
}

.rectangle-52 {
	background-color: var(--thunder);
	border-radius: 2px;
	height: 12px;
	left: 16px;
	position: absolute;
	top: 0;
	width: 12px;
}

.rectangle-54 {
	background-color: var(--tangerine);
	border-radius: 2px;
	height: 12px;
	left: 16px;
	position: absolute;
	top: 14px;
	width: 12px;
}

.text-69 {
	left: 97px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 140px;
	width: 477px;
}

.group-73 {
	height: 26px;
	left: 17px;
	position: absolute;
	top: 151px;
	width: 29px;
}

.rectangle-56 {
	background-color: var(--thunder);
	border-radius: 2px;
	height: 20px;
	left: 8px;
	position: absolute;
	top: 6px;
	width: 21px;
}

.rectangle-55 {
	background-color: var(--tangerine);
	border-radius: 2px;
	height: 21px;
	left: 1px;
	position: absolute;
	top: 0;
	width: 22px;
}

.users-2 {
	height: 26px;
	left: 16px;
	position: absolute;
	top: 265px;
	width: 32px;
}

.group-123 {
	height: 572px;
	left: 89px;
	position: absolute;
	top: 958px;
	width: 1445px;
}

.text-70 {
	left: 0;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 314px;
	width: 610px;
}

.text-71 {
	left: 0;
	letter-spacing: 0;
	line-height: 64px;
	position: absolute;
	top: 166px;
	width: 619px;
}

.group-122 {
	height: 572px;
	left: 798px;
	position: absolute;
	top: 0;
	width: 684px;
}

.group-93 {
	display: flex;
	gap: 179px;
	height: 685px;
	left: 42px;
	position: absolute;
	top: 1732px;
	width: 1461px;
}

.group-92 {
	height: 684.96px;
	position: relative;
	width: 685.99px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.group-92:hover {
	transform: translateY(-10px);
}

.ellipse-105 {
	background-color: #34e6a5;
	border-radius: 9.58px;
	height: 19px;
	left: 16px;
	position: absolute;
	top: 632px;
	width: 19px;
}

.ellipse-108 {
	background-color: #f3528c;
	border-radius: 10px/9px;
	height: 18px;
	left: 662px;
	position: absolute;
	top: 390px;
	width: 20px;
}

.ellipse-106 {
	background-color: #677ef3;
	border-radius: 49.82px;
	height: 100px;
	left: 0;
	position: absolute;
	top: 26px;
	width: 100px;
}

.ellipse-107 {
	background-color: #f3a267;
	border-radius: 11.5px;
	height: 23px;
	left: 118px;
	position: absolute;
	top: 0;
	width: 23px;
}

.rectangle-63 {
	background-color: var(--white);
	border-radius: 18.21px;
	box-shadow: 0px 9.1px 43.69px #272a6e1a;
	height: 615px;
	left: 46px;
	position: absolute;
	top: 46px;
	width: 567px;
}

.text-74 {
	color: #55578d;
	font-family: var(--font-family-poppins);
	font-size: 31px;
	font-weight: 600;
	left: 84px;
	letter-spacing: 0;
	line-height: 49.5px;
	position: absolute;
	top: 143px;
	width: 364px;
}

.group-90 {
	height: 84px;
	left: 493px;
	position: absolute;
	top: 30px;
	transform: rotate(-9.87deg);
	width: 93px;
}

.ellipse-102 {
	background-color: var(--white);
	border-radius: 46.48px/42.09px;
	box-shadow: 0px 3.64px 40.05px #2f327d1a;
	height: 84px;
	left: 0;
	position: absolute;
	top: 0;
	width: 93px;
}

.ellipse-101 {
	border: 2.73px solid;
	border-color: #ee3075;
	border-radius: 26.15px/23.67px;
	height: 47px;
	left: 20px;
	position: absolute;
	top: 18px;
	width: 52px;
}

.vector-7 {
	height: 20px;
	left: 35px;
	position: absolute;
	top: 32px;
	transform: rotate(9.87deg);
	width: 22px;
}

.group-88 {
	height: 84px;
	left: 562px;
	position: absolute;
	top: 84px;
	transform: rotate(12.54deg);
	width: 93px;
}

.ellipse-102-1 {
	background-color: var(--white);
	border-radius: 46.38px/42.2px;
	box-shadow: 0px 3.64px 40.05px #2f327d1a;
	height: 84px;
	left: 0;
	position: absolute;
	top: 0;
	width: 93px;
}

.group-85 {
	height: 47px;
	left: 20px;
	position: absolute;
	top: 18px;
	width: 52px;
}

.ellipse-101-1 {
	border: 2.73px solid;
	border-color: #2dd38e;
	border-radius: 26.09px/23.74px;
	height: 47px;
	left: 1px;
	position: absolute;
	top: 1px;
	width: 52px;
}

.vector-6 {
	height: 15px;
	left: 13px;
	position: absolute;
	top: 18px;
	transform: rotate(-12.54deg);
	width: 28px;
}

.rectangle-64 {
	background-color: #cdd8ff;
	border-radius: 72.82px;
	height: 48px;
	left: 84px;
	position: absolute;
	top: 82px;
	width: 174px;
}

.text-75 {
	color: #707eb0;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-m);
	font-weight: 700;
	left: calc(50% - 216px);
	letter-spacing: 0;
	line-height: 32px;
	position: absolute;
	top: 90px;
	white-space: nowrap;
	width: 108px;
}

.mask-group-2 {
	height: 300px;
	left: 84px;
	position: absolute;
	top: 303px;
	width: 500px;
}

.group-89 {
	height: 131px;
	left: 213px;
	position: absolute;
	top: 554px;
	width: 446px;
}

.rectangle-65 {
	background-color: var(--white);
	border-radius: 18.21px;
	box-shadow: 0px 18.21px 52.8px #272a6e14;
	height: 131px;
	left: 1px;
	position: absolute;
	top: 0;
	width: 444px;
}

.ellipse-103 {
	background-color: var(--iceberg);
	border-radius: 22.74px/20.95px;
	height: 42px;
	left: 375px;
	position: absolute;
	top: 74px;
	width: 45px;
}

.ellipse-104 {
	background-color: var(--iceberg);
	border-radius: 36.15px/32.48px;
	height: 65px;
	left: 49px;
	position: absolute;
	top: 37px;
	width: 72px;
}

.text-76 {
	color: #41be90;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-m);
	font-weight: 600;
	left: 151px;
	letter-spacing: 0;
	line-height: 32px;
	position: absolute;
	top: 29px;
	width: 258px;
}

.group-86 {
	height: 84px;
	left: 35px;
	position: absolute;
	top: 24px;
	width: 107px;
}

.group-118 {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 308px;
	margin-top: 136px;
	width: 600px;
}

.text-73 {
	height: 128px;
	letter-spacing: 0;
	line-height: 64px;
	width: 531px;
}

.text-72 {
	height: 160px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	width: 596px;
}

.group-125 {
	height: 560px;
	left: 0;
	position: absolute;
	top: 2559px;
	width: 1549px;
}

.text-77 {
	left: 0;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 300px;
	width: 646px;
}

.text-78 {
	left: 0;
	letter-spacing: 0;
	line-height: 64px;
	position: absolute;
	top: 211px;
	white-space: nowrap;
	width: 577px;
}

.group-124 {
	height: 560px;
	left: 737px;
	position: absolute;
	top: 0;
	width: 818px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}
.group-124:hover {
	transform: translateY(-10px);
}
.rectangle-75 {
	background-color: #d2e7ff;
	border-radius: 20px;
	height: 208px;
	left: 26px;
	position: absolute;
	top: 352px;
	width: 289px;
}

.ellipse-112 {
	background-color: var(--anakiwa);
	border-radius: 10px/9.98px;
	height: 20px;
	left: 780px;
	position: absolute;
	top: 41px;
	width: 20px;
}

.ellipse-113 {
	background-color: var(--anakiwa);
	border-radius: 21.99px/21.96px;
	height: 44px;
	left: 712px;
	position: absolute;
	top: 7px;
	width: 44px;
}

.rectangle-65-1 {
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 0px 10px 48px #272a6e1a;
	height: 479px;
	left: 46px;
	position: absolute;
	top: 61px;
	width: 718px;
}

.rectangle-66 {
	background-color: #54aef0;
	border-radius: 20px 20px 0px 0px;
	height: 70px;
	left: 46px;
	position: absolute;
	top: 61px;
	width: 718px;
}

.rectangle-71 {
	background-color: #39c6f2;
	height: 30px;
	left: 46px;
	position: absolute;
	top: 241px;
	width: 127px;
}

.rectangle-72 {
	background-color: #68f145;
	height: 30px;
	left: 46px;
	position: absolute;
	top: 392px;
	width: 260px;
}

.rectangle-73 {
	background-color: #3188ef;
	height: 30px;
	left: 459px;
	position: absolute;
	top: 214px;
	width: 305px;
}

.rectangle-74 {
	background-color: #f13b3b;
	height: 30px;
	left: 618px;
	position: absolute;
	top: 335px;
	width: 146px;
}

.text-79 {
	color: #f1fdff;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 600;
	left: 306px;
	letter-spacing: 0;
	line-height: 35.2px;
	position: absolute;
	top: 79px;
	white-space: nowrap;
	width: 274px;
}

.group-91 {
	height: 59px;
	left: 535px;
	position: absolute;
	top: 456px;
	width: 200px;
}

.rectangle-68 {
	background-color: #079be5;
	border-radius: 60px;
	filter: blur(27px);
	height: 26px;
	left: 13px;
	position: absolute;
	top: 33px;
	width: 176px;
}

.rectangle-67 {
	background: linear-gradient(
		97deg,
		rgba(133, 212, 251, 1) 36%,
		rgba(59, 183, 255, 1) 87%
	);
	border-radius: 60px;
	height: 58px;
	left: 0;
	position: absolute;
	top: 0;
	width: 198px;
}

.text-80 {
	left: calc(50% - 85px);
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 18px);
	width: 168px;
}

.mask-group-3 {
	height: 85px;
	left: 124px;
	position: absolute;
	top: 209px;
	width: 85px;
}

.mask-group-4 {
	height: 85px;
	left: 266px;
	position: absolute;
	top: 359px;
	width: 85px;
}

.mask-group-5 {
	height: 85px;
	left: 416px;
	position: absolute;
	top: 186px;
	width: 85px;
}

.mask-group-6 {
	height: 83px;
	left: 582px;
	position: absolute;
	top: 305px;
	width: 82px;
}

.rectangle-67-1 {
	background-color: #cdf3ff;
	border-radius: 60px;
	height: 50px;
	left: 185px;
	position: absolute;
	top: 252px;
	width: 100px;
}

.rectangle-68-1 {
	background-color: #d7ffcd;
	border-radius: 60px;
	height: 50px;
	left: 327px;
	position: absolute;
	top: 407px;
	width: 100px;
}

.rectangle-69 {
	background-color: #cde4ff;
	border-radius: 60px;
	height: 50px;
	left: 409px;
	position: absolute;
	top: 256px;
	width: 100px;
}

.rectangle-70 {
	background-color: #ffcdcd;
	border-radius: 60px;
	height: 50px;
	left: 518px;
	position: absolute;
	top: 357px;
	width: 100px;
}

.number {
	color: #43869b;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 500;
	left: 217px;
	letter-spacing: 0;
	line-height: 35.2px;
	position: absolute;
	top: 260px;
	white-space: nowrap;
	width: 36px;
}

.number-1 {
	color: #4e8c3e;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 500;
	left: 363px;
	letter-spacing: 0;
	line-height: 35.2px;
	position: absolute;
	top: 415px;
	white-space: nowrap;
	width: 29px;
}

.number-2 {
	color: #486e9c;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 500;
	left: 444px;
	letter-spacing: 0;
	line-height: 35.2px;
	position: absolute;
	top: 264px;
	white-space: nowrap;
	width: 44px;
}

.number-3 {
	color: #9e5555;
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 500;
	left: 554px;
	letter-spacing: 0;
	line-height: 35.2px;
	position: absolute;
	top: 365px;
	white-space: nowrap;
	width: 27px;
}

.star-6 {
	height: 29px;
	left: 154px;
	position: absolute;
	top: 277px;
	width: 30px;
}

.group-94 {
	height: 132px;
	left: 13px;
	position: absolute;
	top: 13px;
	transform: rotate(-13.28deg);
	width: 132px;
}

.ellipse-115 {
	background-color: var(--white);
	border-radius: 65.97px/65.89px;
	box-shadow: 0px 10px 48px #282b6f1a;
	height: 132px;
	left: 1px;
	opacity: 0.8;
	position: absolute;
	top: 0;
	width: 132px;
}

.ellipse-114 {
	background-color: var(--white);
	border-radius: 49.97px/49.92px;
	box-shadow: 0px 10px 48px #282b6f1a;
	height: 100px;
	left: 16px;
	position: absolute;
	top: 16px;
	transform: rotate(-0.01deg);
	width: 100px;
}

.star-7 {
	height: 93px;
	left: 18px;
	position: absolute;
	top: 18px;
	transform: rotate(13.28deg);
	width: 92px;
}

.group-95 {
	height: 196px;
	left: 650px;
	position: absolute;
	top: 62px;
	width: 196px;
}

.group-96 {
	height: 35px;
	left: 3px;
	position: absolute;
	top: 484px;
	width: 82px;
}

.vector-8 {
	height: 15px;
	left: -1px;
	position: absolute;
	top: -1px;
	width: 84px;
}

.vector-9 {
	height: 15px;
	left: -1px;
	position: absolute;
	top: 10px;
	width: 84px;
}

.vector-10 {
	height: 15px;
	left: -1px;
	position: absolute;
	top: 22px;
	width: 84px;
}

.group-107 {
	display: flex;
	gap: 152.5px;
	height: 511px;
	left: 41px;
	position: absolute;
	top: 3264px;
	width: 1451px;
}

.group-106 {
	height: 511.03px;
	position: relative;
	width: 793.5px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.group-106:hover {
	transform: translateY(-10px);
}

.ellipse-118 {
	border: 18.83px solid;
	border-color: var(--scooter);
	border-radius: 56.49px;
	height: 113px;
	left: 599px;
	position: absolute;
	top: 0;
	width: 113px;
}

.polygon-3 {
	height: 23px;
	left: 755px;
	position: absolute;
	top: 121px;
	width: 38px;
}

.rectangle-79-1 {
	background-color: #73bcff;
	border-radius: 18.83px;
	height: 193px;
	left: 0;
	position: absolute;
	top: 223px;
	width: 197px;
}

.group-104 {
	height: 365px;
	left: 19px;
	position: absolute;
	top: 31px;
	width: 658px;
}

.group-67-1 {
	background-color: #f4f4f4;
	border-radius: 18.83px;
	height: 365px;
	left: 0;
	position: absolute;
	top: 0;
	width: 658px;
}

.rectangle-50-1 {
	background-color: var(--gray-nurse);
	border-radius: 18.83px 18.83px 0px 0px;
	height: 26px;
	left: 0;
	position: absolute;
	top: 0;
	width: 658px;
}

.ellipse-16-1 {
	background-color: var(--sunglo);
	border-radius: 6.45px;
	height: 13px;
	left: 13px;
	position: absolute;
	top: 6px;
	width: 13px;
}

.ellipse-17-1 {
	background-color: var(--cream-can);
	border-radius: 6.45px;
	height: 13px;
	left: 32px;
	position: absolute;
	top: 6px;
	width: 13px;
}

.ellipse-18-1 {
	background-color: var(--pastel-green);
	border-radius: 6.45px;
	height: 13px;
	left: 52px;
	position: absolute;
	top: 6px;
	width: 13px;
}

.group-55-1 {
	height: 39px;
	left: 16px;
	position: absolute;
	top: 296px;
	width: 171px;
}

.rectangle-43-1 {
	background-color: var(--royal-blue);
	border-radius: 38.67px;
	box-shadow: 0px 6.45px 15.47px #3465e14c;
	height: 39px;
	left: 1px;
	position: absolute;
	top: 0;
	width: 169px;
}

.text-83 {
	left: 20px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 9px;
	width: 127px;
}

.group-56-1 {
	height: 39px;
	left: 196px;
	position: absolute;
	top: 296px;
	width: 142px;
}

.rectangle-44-1 {
	background-color: #e13367;
	border-radius: 38.67px;
	box-shadow: 0px 6.45px 15.47px #c92e5d4c;
	height: 39px;
	left: 0;
	position: absolute;
	top: 0;
	width: 140px;
}

.text-84 {
	left: 35px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 8px;
	width: 94px;
}

.phone-1-1 {
	background-image: url(~@/assets/cdn-animaapp/vector-14.svg);
	background-size: 100% 100%;
	height: 13px;
	left: 10px;
	position: absolute;
	top: 13px;
	width: 16px;
}

.group-64-1 {
	background-size: 100% 100%;
	height: 122px;
	left: 500px;
	position: absolute;
	top: 70px;
	width: 126px;
}

.group-63-1 {
	background-size: 100% 100%;
	height: 122px;
	left: 347px;
	position: absolute;
	top: 70px;
	width: 126px;
}

.group-101 {
	height: 249px;
	left: 5px;
	position: absolute;
	top: 51px;
	width: 255px;
}

.rectangle-77 {
	-webkit-backdrop-filter: blur(4.71px) brightness(100%);
	backdrop-filter: blur(4.71px) brightness(100%);
	background-color: #87a6e31a;
	border-radius: 18.83px;
	height: 363px;
	left: 1px;
	position: absolute;
	top: 1px;
	width: 658px;
}

.group-103 {
	height: 385px;
	left: 86px;
	position: absolute;
	top: 126px;
	width: 643px;
}

.rectangle-76 {
	background-color: var(--white);
	border-radius: 18.83px;
	box-shadow: 0px 18.83px 47.08px #2f327d1a;
	height: 385px;
	left: 0;
	position: absolute;
	top: 0;
	width: 639px;
}

.rectangle-78-1 {
	background-color: var(--gray-nurse);
	border-radius: 18.83px 18.83px 0px 0px;
	height: 25px;
	left: 0;
	position: absolute;
	top: 0;
	width: 639px;
}

.group-57-1 {
	background-size: 100% 100%;
	height: 201px;
	left: 54px;
	position: absolute;
	top: 68px;
	width: 200px;
}

.group-99 {
	background-size: 100% 100%;
	display: flex;
	height: 201px;
	left: 401px;
	position: absolute;
	top: 69px;
	width: 200px;
}

.group-62-1 {
	height: 27.04px;
	margin-left: 10.7px;
	margin-top: 162.9px;
	position: relative;
	width: 172.21px;
}

.rectangle-6-8 {
	-webkit-backdrop-filter: blur(6.63px) brightness(100%);
	backdrop-filter: blur(6.63px) brightness(100%);
	background-color: var(--periwinkle);
	border-radius: 6.63px;
	height: 27px;
	left: 0;
	position: absolute;
	top: 0;
	width: 170px;
}

.text-85 {
	color: var(--white);
	font-family: var(--font-family-nunito_sans);
	font-size: 13.3px;
	font-weight: 600;
	left: 28px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 9px);
	width: 133px;
}

.group-58-1 {
	display: flex;
	gap: 1.7px;
	height: 10px;
	left: 9px;
	position: absolute;
	top: 9px;
	width: 11px;
}

.rectangle-46-1 {
	background-color: var(--white);
	border-radius: 0.66px;
	height: 4.85px;
	margin-left: 0;
	margin-top: 4.9px;
	width: 2.57px;
}

.rectangle-47-1 {
	background-color: var(--white);
	border-radius: 0.66px;
	height: 7.28px;
	margin-top: 2.4px;
	width: 2.57px;
}

.rectangle-48-1 {
	background-color: var(--white);
	border-radius: 0.66px;
	height: 9.71px;
	margin-top: 0;
	width: 2.57px;
}

.group-100 {
	height: 45px;
	left: 425px;
	position: absolute;
	top: 313px;
	width: 178px;
  cursor: pointer;
}

.rectangle-68-2 {
	background-color: #eb493a;
	border-radius: 56.49px;
	filter: blur(25.42px);
	height: 29px;
	left: 2px;
	position: absolute;
	top: 17px;
	width: 173px;
}

.rectangle-67-2 {
	background: linear-gradient(
		106deg,
		rgba(245, 84, 84, 1) 0%,
		rgba(229, 66, 43, 1) 100%
	);
	border-radius: 56.49px;
	height: 44px;
	left: 1px;
	position: absolute;
	top: 0;
	width: 176px;
}

.text-86 {
	color: var(--white);
	font-family: var(--font-family-poppins);
	font-size: 20.7px;
	font-weight: 700;
	left: 13px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	text-align: center;
	top: 6px;
	width: 156px;
}

.group-100:hover .rectangle-67-2 {
    animation: pulse-red 0.6s ease-in-out infinite alternate;
}

@keyframes pulse-red {
    from {
        box-shadow: 0 0 0 0 rgba(235, 73, 58, 0.7);
    }
    to {
        box-shadow: 0 0 0 10px rgba(235, 73, 58, 0);
    }
}

.text-87 {
	color: var(--pale-sky);
	font-family: var(--font-family-nunito_sans);
	font-size: 22.6px;
	font-weight: 700;
	left: 31px;
	letter-spacing: 0;
	line-height: 36.2px;
	position: absolute;
	top: 290px;
	width: 370px;
}

.text-88 {
	color: #a7a7b5;
	font-family: var(--font-family-nunito_sans);
	font-size: 16.9px;
	font-weight: 600;
	left: 22px;
	letter-spacing: 0;
	line-height: 27.1px;
	position: absolute;
	top: 336px;
	width: 374px;
}

.group-102 {
	display: flex;
	gap: 6.2px;
	height: 13px;
	left: 28px;
	position: absolute;
	top: 6px;
	width: 49px;
}

.ellipse-16-2 {
	background-color: var(--sunglo);
	border-radius: 6.15px/6.4px;
	height: 12.8px;
	margin-left: 0;
	margin-top: 0;
	width: 12.31px;
}

.ellipse-17-2 {
	background-color: var(--cream-can);
	border-radius: 6.15px/6.4px;
	height: 12.8px;
	width: 12.31px;
}

.ellipse-18-2 {
	background-color: var(--pastel-green);
	border-radius: 6.15px/6.4px;
	height: 12.8px;
	margin-top: 0;
	width: 12.31px;
}

.line-9 {
	height: 207px;
	left: 333px;
	position: absolute;
	top: 64px;
	width: 1px;
}

.group-105 {
	height: 101px;
	left: 69px;
	position: absolute;
	top: 163px;
	transform: rotate(-6.16deg);
	width: 101px;
}

.ellipse-117 {
	background-color: var(--white);
	border-radius: 50.4px;
	box-shadow: 0px 9.42px 45.19px #282b6f26;
	height: 101px;
	left: 0;
	opacity: 0.8;
	position: absolute;
	top: 1px;
	width: 101px;
}

.ellipse-116 {
	background-color: var(--white);
	border-radius: 39.37px;
	box-shadow: 0px 9.42px 45.19px #282b6f26;
	height: 79px;
	left: 11px;
	position: absolute;
	top: 11px;
	width: 79px;
}

.user-friends-1 {
	height: 36px;
	left: 28px;
	overflow: hidden;
	position: absolute;
	top: 32px;
	width: 45px;
}

.vector-1 {
	height: 90.17%;
	left: 0;
	position: absolute;
	top: 9.58%;
	transform: rotate(12.32deg);
	width: 99.52%;
}

.group-119 {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: 268px;
	margin-top: 116px;
	width: 509px;
}

.text-82 {
	height: 128px;
	letter-spacing: 0;
	line-height: 64px;
	width: 339px;
}

.text-81 {
	height: 120px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	width: 505px;
}

.view-5 {
	height: 875px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 215px;
	position: relative;
	width: min(1455px, calc(100% - 40px));
	max-width: 1455px;
}

.x1-1 {
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 0px 18.83px 47.08px #2f327d1a;
	display: flex;
	gap: 22.7px;
	height: 681px;
	left: 0;
	position: absolute;
	top: 194px;
	width: 1453px;
  cursor: pointer;
}

.group-245 {
	display: flex;
	flex-direction: column;
	gap: 37.5px;
	height: 354.21px;
	margin-left: 52.2px;
	margin-top: 107px;
	width: 633.01px;
}

.text-54 {
	color: var(--thunder);
	font-family: var(--font-family-poppins);
	font-size: 30px;
	font-weight: 700;
	height: 119.17px;
	letter-spacing: 0;
	line-height: 54px;
	margin-left: 0;
	margin-top: 0;
	width: 629.01px;
}

.text-53 {
	height: 197.52px;
	letter-spacing: 0.5px;
	line-height: 45px;
	margin-left: 0;
	width: 544.29px;
}

.group-40 {
	height: 456.83px;
	margin-top: 109.2px;
	width: 707.93px;
}

.rectangle-206 {
	background-color: var(--azure-radiance-8);
	height: 79px;
	left: 72px;
	position: absolute;
	top: 86px;
	width: 435px;
}

.rectangle-205 {
	background-color: var(--azure-radiance-8);
	height: 86px;
	left: 415px;
	position: absolute;
	top: 0;
	width: 380px;
}

.text-55 {
	left: 81px;
	letter-spacing: 0.8px;
	line-height: 72px;
	position: absolute;
	top: 11px;
	width: 895px;
}

.view-6 {
	align-self: center;
	height: 1835px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 215px;
	position: relative;
	width: min(1905px, calc(100% - 30px));
	max-width: 1905px;
}

.rectangle {
	background-color: var(--cornflower);
	border-radius: 0px 0px 100px 0px;
	height: 1837px;
	left: calc(50% - 864px);
	opacity: 0.2;
	position: absolute;
	top: -1px;
	width: 1471px;
}

.x2-1 {
	height: 506px;
	left: 0;
	position: absolute;
	top: 1199px;
	width: 1903px;
}

.rectangle-4 {
	background-color: var(--black);
	border-radius: 29.5px;
	height: 85px;
	left: -1px;
	opacity: 0.05;
	position: absolute;
	top: 422px;
	width: 1903px;
}

.group-454 {
	height: 402px;
	left: 23px;
	position: absolute;
	top: 75px;
	width: 595px;
  border-radius: 40px;
	cursor: pointer;
}

.rectangle-199 {
	background-color: var(--white);
	border: 2px solid;
	border-color: var(--aqua-pearl);
	border-radius: 44px;
	height: 402px;
	left: 0;
	position: absolute;
	top: 0;
	width: 597px;
}

.x,
.x-2,
.x-4,
.x-6,
.x-8 {
	left: calc(50% + 24px);
	letter-spacing: 0;
	line-height: 26px;
	position: absolute;
	top: calc(50% - 177px);
	max-height: 78px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow-wrap: anywhere;
	width: 227px;
}

.x-1 {
	left: calc(50% + 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 266px;
}

.group-457 {
	height: 350px;
	left: 25px;
	position: absolute;
	top: 25px;
	width: 265px;
}

.group-457-1 {
	height: 402px;
	left: 643px;
	position: absolute;
	top: 75px;
	width: 595px;
  border-radius: 40px;
}

.x-3 {
	left: calc(50% + 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 266px;
}

.group-458 {
	height: 402px;
	left: 1263px;
	position: absolute;
	top: 75px;
	width: 595px;
  border-radius: 40px;
}

.x-5 {
	left: calc(50% + 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 266px;
}

.text-47 {
	left: 13.29%;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 250px);
	white-space: nowrap;
	width: 34.94%;
}

.x1-2 {
	height: 535px;
	left: 4px;
	position: absolute;
	top: 495px;
	width: 1903px;
}

.rectangle-5 {
	background-color: var(--black);
	border-radius: 29.5px;
	height: 85px;
	left: -1px;
	opacity: 0.05;
	position: absolute;
	top: 451px;
	width: 1903px;
}

.group-454-1 {
	height: 402px;
	left: 23px;
	position: absolute;
	top: 104px;
	width: 595px;
}

.group-454-1,
.group-457-2,
.group-458-1{
border-radius: 40px;
}

.x-7 {
	left: calc(50% + 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 266px;
}

.group-457-2 {
	height: 402px;
	left: 643px;
	position: absolute;
	top: 104px;
	width: 595px;
}

.x-9 {
	left: calc(50% + 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 266px;
}

.group-458-1 {
	height: 402px;
	left: 1263px;
	position: absolute;
	top: 104px;
	width: 595px;
}

.x-10 {
	left: calc(50% - 2px);
	letter-spacing: 0;
	line-height: 26px;
	position: absolute;
	top: calc(50% - 177px);
	max-height: 78px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow-wrap: anywhere;
	width: 281px;
}

.x-11 {
	left: calc(50% - 2px);
	letter-spacing: 0.3px;
	line-height: 27px;
	position: absolute;
	top: calc(50% - 92px);
	width: 283px;
}

.text-52 {
	left: 13.08%;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 268px);
	white-space: nowrap;
	width: 36.36%;
}

.view-7 {
	height: 7.01%;
	left: 13.28%;
	overflow: hidden;
	position: absolute;
	top: 13.61%;
	width: 49.03%;
}

.text_label-2 {
	color: #636363;
	font-family: var(--font-family-roboto);
	font-size: 24px;
	font-weight: 500;
	height: 20.99%;
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 70.34%;
	white-space: nowrap;
	width: 104.82%;
}

.text_label-3 {
	color: var(--black-16);
	font-family: var(--font-family-roboto);
	font-size: 45px;
	font-weight: 700;
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: calc(50% - 43px);
	white-space: nowrap;
	width: 72.38%;
}

.view-8 {
	height: 864px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 215px;
	position: relative;
	width: min(1384px, calc(100% - 40px));
	max-width: 1384px;
}

.x-12 {
	height: 864px;
	left: 645px;
	position: absolute;
	top: 0;
	width: 739px;
}

.mask-group-7 {
	height: 700px;
	left: 121px;
	position: absolute;
	top: 0;
	width: 560px;
  border-radius: 20px;
  object-fit: cover;
}

.x-13 {
	height: 329px;
	left: 0;
	position: absolute;
	top: 535px;
	width: 686px;
}

.rectangle-28 {
	background-color: var(--white);
	border-radius: 20px;
	box-shadow: 2px 4px 60px #292c7c1a;
	height: 329px;
	left: 0;
	position: absolute;
	top: 0;
	width: 680px;
}

.rectangle-30 {
	background-color: #f67766;
	border-radius: 20px 0px 0px 20px;
	box-shadow: 2px 4px 60px #292c7c1a;
	height: 329px;
	left: 0;
	position: absolute;
	top: 0;
	width: 14px;
}

.line-3 {
	height: 139px;
	left: 54px;
	object-fit: cover;
	position: absolute;
	top: 49px;
	width: 1px;
}

.text-35 {
	color: var(--storm-dust);
	font-family: var(--font-family-nunito_sans);
	font-size: var(--font-size-l);
	font-weight: 400;
	left: 87px;
	letter-spacing: 0.44px;
	line-height: 39.6px;
	position: absolute;
	top: 41px;
	width: 534px;
}

.text-36 {
	color: var(--thunder);
	font-family: var(--font-family-nunito_sans);
	font-size: 24px;
	font-weight: 600;
	left: 87px;
	letter-spacing: 0;
	line-height: 43.2px;
	position: absolute;
	top: 244px;
	white-space: nowrap;
}
::-webkit-scrollbar {
	width: 0;
}

.address-3 {
	color: #63636378;
	font-family: var(--font-family-nunito_sans);
	font-size: var(--font-size-s);
	font-weight: 600;
	left: 463px;
	letter-spacing: 0.36px;
	line-height: 32.4px;
	position: absolute;
	top: 268px;
	white-space: nowrap;
}

.group-29 {
	display: flex;
	gap: 5.5px;
	height: 24px;
	left: 501px;
	position: absolute;
	top: 232px;
	width: 137px;
}

.star-1 {
	height: 21.69px;
	margin-left: 0.6px;
	width: 22.8px;
}

.star {
	height: 21.69px;
	width: 22.8px;
}

.group-51 {
	background-color: var(--white);
	border-radius: 40px;
	box-shadow: 0px 4px 60px #282b7c26;
	display: flex;
	height: 80px;
	left: 659px;
	position: absolute;
	top: 288px;
	width: 80px;
}

.vector-5 {
	height: 23.07px;
	margin-left: 32.7px;
	margin-top: 28.5px;
	width: 16.41px;
}

.x-14 {
	display: flex;
	flex-direction: column;
	height: 697px;
	left: 0;
	position: absolute;
	top: 0;
	width: 700px;
}

.x-15 {
	display: flex;
	gap: 30px;
	width: 313px;
}

.line-4 {
	height: 1px;
	margin-top: 13px;
	object-fit: cover;
	width: 80px;
}

.text-42 {
	color: var(--storm-dust);
	font-family: var(--font-family-nunito_sans);
	font-size: var(--font-size-m);
	font-weight: 400;
	height: 27px;
	letter-spacing: 4px;
	line-height: normal;
	white-space: nowrap; /* добавьте эту строку */
	width: 203px;
}

.text-41 {
	color: var(--thunder);
	font-family: var(--font-family-nunito_sans);
	font-size: 50px;
	font-weight: 700;
	height: 68px;
	letter-spacing: 0;
	line-height: normal;
	margin-top: 32px;
	width: 692px;
}

.text-40 {
	height: 84px;
	letter-spacing: 0.52px;
	line-height: 41.6px;
	margin-left: 5px;
	margin-top: 43px;
	width: 607px;
}

.text-39 {
	height: 168px;
	letter-spacing: 0.52px;
	line-height: 41.6px;
	margin-left: 5px;
	margin-top: 26px;
	width: 573px;
}

.text-38 {
	height: 84px;
	letter-spacing: 0.52px;
	line-height: 41.6px;
	margin-top: 32px;
	width: 496px;
}

.group-459 {
	height: 80px;
	margin-left: 5px;
	margin-top: 53px;
	position: relative;
	width: 354px;
  cursor: pointer;
}
.group-459:hover .rectangle-29 {
    box-shadow: 0 0 15px 5px rgba(0, 123, 255, 0.5);
    opacity: 0.3;
}
.group-459:hover .arrow-2 {
    animation: shake 0.5s ease-in-out infinite alternate;
}

@keyframes shake {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(5px);
    }
}

.rectangle-29 {
	border: 1px solid;
	border-color: var(--aqua-pearl);
	border-radius: 80px;
	height: 80px;
	left: 0;
	position: absolute;
	top: 0;
	width: 352px;
  cursor: pointer;
}

.text-37 {
	color: var(--aqua-pearl);
	font-family: var(--font-family-poppins);
	font-size: var(--font-size-l);
	font-weight: 400;
	left: calc(50% - 125px);
	letter-spacing: 0.44px;
	line-height: 35.2px;
	position: absolute;
	top: calc(50% - 17px);
	white-space: nowrap;
}

.group-32 {
	border: 1px solid;
	border-color: var(--aqua-pearl);
	border-radius: 40px;
	display: flex;
	height: 80px;
	left: 272px;
	position: absolute;
	top: 0;
	width: 80px;
  cursor: pointer;
}

.arrow-2 {
	height: 14.73px;
	margin-left: 27px;
	margin-top: 32.6px;
	width: 26px;
}

.view-9 {
	align-self: center;
	height: 872px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 172px;
	position: relative;
	width: min(1530px, calc(100% - 40px));
	max-width: 1530px;
}

.x50 {
	height: 682px;
	left: 0;
	position: absolute;
	top: 163px;
	width: 542px;
}

.group-40-1 {
	background-position: 50% 50%;
	background-size: cover;
	height: 294px;
	left: 0;
	position: absolute;
	top: 0;
	width: 475px;
  border-radius: 20px;
}

.metall-traderu {
	color: var(--thunder);
	font-family: var(--font-family-poppins);
	font-size: 26px;
	font-weight: 500;
	left: 0;
	letter-spacing: 0;
	line-height: 46.8px;
	position: absolute;
	top: 394px;
	width: 534px;
}

.address-4 {
	color: var(--storm-dust);
	font-family: var(--font-family-nunito_sans);
	font-size: var(--font-size-s);
	font-weight: 600;
	left: 155px;
	letter-spacing: 0.36px;
	line-height: 32.4px;
	position: absolute;
	top: 335px;
	white-space: nowrap;
}

.text-31 {
	left: 0;
	letter-spacing: 0.4px;
	line-height: 36px;
	position: absolute;
	top: 511px;
	width: 531px;
}

.text-32 {
	left: 0;
	letter-spacing: 0.4px;
	line-height: 36px;
	position: absolute;
	text-decoration: underline;
	top: 645px;
	white-space: nowrap;
	width: 155px;
  cursor: pointer;
}
.text-32:hover{
  opacity: 0.6;
}

.text-34 {
	color: var(--thunder);
	font-family: var(--font-family-nunito_sans);
	font-size: 48px;
	font-weight: 700;
	left: calc(50% - 410px);
	letter-spacing: 0;
	line-height: 86.4px;
	position: absolute;
	top: 0;
	white-space: nowrap;
}

.view-10 {
	display: flex;
	margin-top: 150px;
	width: 100%;
	max-width: 1920px;
	margin-left: auto;
	margin-right: auto;
}

.footer {
	background-color: transparent;
	position: relative;
	width: 100%;
	max-width: 1920px;
	margin: 0 auto;
	height: 1132px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.rectangle-80-2 {
	background-color: var(--thunder);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
}

.footer-content {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 60px 80px 40px;
	position: relative;
	z-index: 2;
	gap: 40px;
	flex-wrap: wrap;
}

.footer-left {
	flex: 1;
	min-width: 300px;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.footer-center {
	flex: 1;
	min-width: 400px;
	display: flex;
	flex-direction: column;
	gap: 30px;
	align-items: center;
}

.footer-right {
	flex: 1;
	min-width: 300px;
	display: flex;
	justify-content: flex-end;
}

.footer-social {
	/* display: flex;
	gap: 50px;
	align-items: center; */
	transform: translateX(-950px);
}

.footer-logo {
	width: 320px;
	height: 180px;
	margin-left: 300px;
	margin-top: 150px;
}

.copyright {
	letter-spacing: 0.88px;
	line-height: normal;
	text-align: center;
	padding: 20px;
	position: relative;
	z-index: 2;
	margin-top: auto;
}

.span-1 {
	letter-spacing: 0.19px;
}

.span1-3 {
	letter-spacing: 0.19px;
}

.group-462 {
	display: flex;
	flex-direction: column;
	height: 407px;
	left: 650px;
	position: absolute;
	top: 560px;
	width: 500px;
}

.map-section {
	width: 1200px;
	height: 700px;
	margin: 120px 0;
}

.map-section iframe {
	width: 100%;
	height: 100%;
	border: none;
	border-radius: 8px; /* опционально */
}

.text-13 {
	height: 33px;
	letter-spacing: 0.88px;
	line-height: normal;
	width: 156px;
	white-space: nowrap;
}

.projectmetall-traderu,
.phone,
.text-12-1 {
    cursor: pointer;
    height: 33px;
    letter-spacing: 0.88px;
    line-height: normal;
    text-align: left;
    white-space: nowrap;
    color: #797979;
    transition: color 0.3s ease;
    margin-top: 9px; /* среднее между 7, 10, 11 */
}

.projectmetall-traderu:hover,
.phone:hover,
.text-12-1:hover {
    color: #ffffff;
}


.text-23 {
	color: var(--nobel);
	font-family: var(--font-family-poppins);
	font-size: 24px;
	font-weight: 500;
	letter-spacing: 1.04px;
	line-height: normal;
	margin-left: 300px;
	white-space: nowrap;
}

.text-24 {
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	line-clamp: 1;
	align-items: flex-end;
	color: var(--white);
	display: -webkit-box;
	font-family: var(--font-family-prosto_one);
	font-size: var(--font-size-l);
	font-weight: 400;
	height: 29px;
	justify-content: center;
	left: 158px;
	letter-spacing: 0;
	line-height: normal;
	overflow: hidden;
	position: absolute;
	text-overflow: ellipsis;
	top: calc(50% + 58px);
	width: 161px;
}

.image-1 {
	aspect-ratio: 2.04;
	height: 157px;
	left: 0;
	position: absolute;
	top: 0;
	width: 320px;
}

/* ========== UX УЛУЧШЕНИЯ - НОВЫЕ СТИЛИ ========== */

/* === 5. SCROLL REVEAL АНИМАЦИИ === */
.reveal-element {
	opacity: 0;
	transform: translateY(30px);
	transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.reveal-element.revealed {
	opacity: 1;
	transform: translateY(0);
}

/* Задержки для последовательного появления */
.reveal-element:nth-child(1) {
	transition-delay: 0s;
}
.reveal-element:nth-child(2) {
	transition-delay: 0.1s;
}
.reveal-element:nth-child(3) {
	transition-delay: 0.2s;
}

/* === 6. HOVER ЭФФЕКТЫ === */

/* Карточки курсов */
.group-454-1,
.group-457-1,
.group-457-2,
.group-458-1 {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	cursor: pointer;
}

.group-454-1:hover,
.group-457-1:hover,
.group-457-2:hover,
.group-458-1:hover {
	transform: translateY(-8px);
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* Карточки преимуществ */
.x3-1,
.x2,
.x1 {
	transition: all 0.3s ease;
}

.x3-1:hover,
.x2:hover,
.x1:hover {
	transform: translateY(-5px) scale(1.02);
}

.x3-1:hover .rectangle-1,
.x2:hover .rectangle-15,
.x1:hover .rectangle-1 {
	box-shadow: 0 15px 70px rgba(38, 44, 117, 0.25);
}

/* Кнопки */
.rectangle-2,
.rectangle-2-1 {
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
}

.rectangle-2::before,
.rectangle-2-1::before {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 0;
	height: 0;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.3);
	transform: translate(-50%, -50%);
	transition: width 0.6s, height 0.6s;
}

.rectangle-2:hover::before,
.rectangle-2-1:hover::before {
	width: 300px;
	height: 300px;
}

.group-1:hover .rectangle-2 {
	box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);
}

.group-113:hover .rectangle-2-1 {
	background-color: rgba(255, 255, 255, 0.2);
	box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);
}

/* === 12. МИКРОАНИМАЦИИ КНОПОК === */

/* Ripple эффект */
@keyframes ripple {
	0% {
		transform: scale(0);
		opacity: 1;
	}
	100% {
		transform: scale(4);
		opacity: 0;
	}
}

.rectangle-2:active::after,
.rectangle-2-1:active::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 20px;
	height: 20px;
	background: rgba(255, 255, 255, 0.5);
	border-radius: 50%;
	transform: translate(-50%, -50%);
	animation: ripple 0.6s ease-out;
}

/* Pulse анимация для CTA кнопок */
@keyframes pulse {
	0%,
	100% {
		box-shadow: 0 0 0 0 rgba(0, 149, 236, 0.7);
	}
	50% {
		box-shadow: 0 0 0 10px rgba(0, 149, 236, 0);
	}
}

.rectangle-24-1 {
	animation: pulse 2s infinite;
}

/* === 11. SKELETON SCREENS === */
.skeleton {
	background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
	background-size: 200% 100%;
	animation: shimmer 1.5s infinite;
	border-radius: 8px;
}

@keyframes shimmer {
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
}

.skeleton-card {
	width: 100%;
	height: 300px;
	margin-bottom: 20px;
}

.skeleton-text {
	width: 100%;
	height: 20px;
	margin-bottom: 10px;
}

/* === 8. ПАРАЛЛАКС === */
.parallax-element {
	will-change: transform;
	transition: transform 0.1s ease-out;
}

/* === АДАПТИВНОСТЬ И ACCESSIBILITY === */

/* Поддержка prefers-reduced-motion */
@media (prefers-reduced-motion: reduce) {
	*,
	*::before,
	*::after {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		transition-duration: 0.01ms !important;
	}

	.reveal-element {
		opacity: 1;
		transform: none;
	}

	.parallax-element {
		transform: none !important;
	}
}

/* Улучшенный focus для accessibility */
a:focus-visible,
button:focus-visible {
	outline: 2px solid #0096ed;
	outline-offset: 2px;
	border-radius: 4px;
}

/* Плавные переходы для всех интерактивных элементов */
a,
button,
.group-1,
.group-113,
.group-20,
.group-21,
.group-37 {
	transition: all 0.3s ease;
}

/* === 1. ПОДЧЁРКИВАНИЕ ПУНКТОВ НАВИГАЦИИ === */
/* Исправлено: подчёркивание применяется к внутреннему div с текстом */
.group-446 a {
	transition: color 0.3s ease;
}

.group-446 a > div {
	position: relative;
	display: inline-block;
}

.group-446 a > div::after {
	content: '';
	position: absolute;
	bottom: -5px;
	left: 0;
	width: 0;
	height: 2px;
	background: white;
	transition: width 0.3s ease;
}

.group-446 a:hover {
	color: #0096ed;
}

.group-446 a:hover > div::after {
	width: 100%;
}

/* === ДОПОЛНИТЕЛЬНЫЕ УЛУЧШЕНИЯ === */

/* Плавное появление изображений после загрузки */
img {
	transition: opacity 0.3s ease;
}

/* Улучшенные тени для карточек */
.rectangle-199 {
	transition: box-shadow 0.3s ease;
}
/* Карточки курсов */

.group-454,
.group-458 {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	cursor: pointer;
}

.group-454:hover,
.group-458:hover {
	transform: translateY(-8px);
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* Анимация для отзывов */
.x-12,
.x-14 {
	transition: all 0.3s ease;
}

.x-12:hover,
.x-14:hover {
	transform: scale(1.02);
}

/* === 2. ЭФФЕКТ 3D НАКЛОНА ЭЛЕМЕНТОВ === */
/* Исправлено: применяется к дочерним элементам, 3D perspective эффект */
.group-452 .view {
	perspective: 1000px;
	transform-style: preserve-3d;
}

.group-452 .view > div {
	transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
	transform-origin: center center;
	transform-style: preserve-3d;
}

.group-452 .view > div:hover {
	transform: perspective(1000px) rotateX(5deg) rotateY(3deg) translateZ(10px);
}

/* Альтернативный вариант для разных дочерних элементов */
.group-452 .view > div:nth-child(odd):hover {
	transform: perspective(1000px) rotateX(-5deg) rotateY(-3deg) translateZ(10px);
}

.group-452 .view > div:nth-child(even):hover {
	transform: perspective(1000px) rotateX(5deg) rotateY(3deg) translateZ(10px);
}

/* === 3. УВЕЛИЧЕНИЕ ЛОГОТИПА ПРИ НАВЕДЕНИИ === */
.logo-container {
	transition: transform 0.3s ease;
	cursor: pointer;
}

.logo-container:hover {
	transform: scale(1.1);
}

/* === 4. УВЕЛИЧЕНИЕ КНОПОК ПРИ НАВЕДЕНИИ === */
.group-20:hover,
.group-21:hover {
	transform: scale(1.05);
	cursor: pointer;
}

/* === 5. ЭФФЕКТЫ ДЛЯ ЭЛЕМЕНТОВ В СЕКЦИИ #view === */
/* Исправлено: эффекты применяются к внутренним rectangle элементам */
.group-55,
.group-55-1 {
	cursor: pointer;
}

.group-55 .rectangle-43,
.group-55-1 .rectangle-43-1 {
	transition: transform 0.3s ease;
}

.group-55:hover .rectangle-43,
.group-55-1:hover .rectangle-43-1 {
	transform: scale(1.1);
}

.group-56,
.group-56-1 {
	cursor: pointer;
}

.group-56 .rectangle-45,
.group-56 .rectangle-44,
.group-56-1 .rectangle-45-1,
.group-56-1 .rectangle-44-1 {
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.group-56:hover .rectangle-45,
.group-56:hover .rectangle-44,
.group-56-1:hover .rectangle-45-1,
.group-56-1:hover .rectangle-44-1 {
	animation: pulse-glow 1.5s infinite;
}

@keyframes pulse-glow {
	0%,
	100% {
		box-shadow: 0 0 0 0 rgba(20, 236, 0, 0.7);
	}
	50% {
		box-shadow: 0 0 20px 10px rgba(12, 223, 29, 0);
	}
}

/* === 6. ПОДСВЕТКА БЛОКА ПРИ НАВЕДЕНИИ === */
/* Исправлено: подсветка применяется к внутреннему rectangle-31 */
.group-37 {
	cursor: pointer;
}

.group-37 .rectangle-31 {
	transition: box-shadow 0.3s ease;
}

.group-37:hover .rectangle-31 {
	box-shadow: 0 0 30px rgba(0, 149, 236, 0.6);
}

/* === 7. ПОДПРЫГИВАНИЕ БЛОКА ПРИ НАВЕДЕНИИ === */
.x1-1 {
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.x1-1:hover {
	transform: translateY(-10px);
	box-shadow: 0px 28px 57px rgba(47, 50, 125, 0.25);
}

/* === 8. ИНТЕРАКТИВНОСТЬ БЛОКА НОВОСТЕЙ === */
/* Исправлено: применяется к конкретным изображениям и элементам */
.x53.x51 img,
.x53.x52 img,
.view-9 > div:nth-child(1) > img {
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.x53.x51 img:hover,
.x53.x52 img:hover,
.view-9 > div:nth-child(1) > img:hover {
	transform: translateY(-5px) scale(1.02);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.x50 .group-40-1 {
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.x50 .group-40-1:hover {
	transform: translateY(-5px) scale(1.02);
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

/* === 9. СЛАЙДЕР ОТЗЫВОВ === */
/* Улучшено: более плавная анимация с увеличенной длительностью */
.review-slider {
	position: relative;
}

.review-slider .x-13,
.review-slider .mask-group-7 {
	transition: opacity 0.3s ease-out;
}

.review-slider .x-13 {
	animation: fadeIn 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-slider .mask-group-7 {
	animation: fadeIn 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateX(10px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

.group-51 {
	cursor: pointer;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.group-51:hover {
	transform: scale(1.1);
	box-shadow: 0px 6px 70px rgba(40, 43, 124, 0.4);
}

.group-51:active {
	transform: scale(0.95);
}

/* Accessibility: отключение анимаций для prefers-reduced-motion */
@media (prefers-reduced-motion: reduce) {
	/* Отключение 3D наклона */
	.group-452 .view > div:hover,
	.group-452 .view > div:nth-child(odd):hover,
	.group-452 .view > div:nth-child(even):hover {
		transform: none;
	}

	/* Отключение пульсации */
	.group-56:hover .rectangle-45,
	.group-56:hover .rectangle-44,
	.group-56-1:hover .rectangle-45-1,
	.group-56-1:hover .rectangle-44-1 {
		animation: none;
	}

	/* Отключение увеличения и других transform эффектов */
	.logo-container:hover,
	.group-20:hover,
	.group-21:hover,
	.group-55:hover .rectangle-43,
	.group-55-1:hover .rectangle-43-1,
	.x1-1:hover,
	.x53.x51 img:hover,
	.x53.x52 img:hover,
	.view-9 > div:nth-child(1) > img:hover,
	.x50 .group-40-1:hover {
		transform: none;
	}

	/* Отключение анимации слайдера */
	.review-slider .x-13,
	.review-slider .mask-group-7 {
		animation: none;
	}

	.group-51:hover {
		transform: none;
	}
}
</style>
